/*=======================================================================
 * $Id$
*
* Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
*
* Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
* Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
* Urheber festgelegten Stelle in der Funktion des Computerprogramms
* angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
* Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
* Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
* =========================================================================*/

 define([
     "underscore",
     "extensions",
     "i18n/i18n",
     "api/v2/api",
     "api/v2/common",
     "backbone",
     "utils/dom",
     "utils/keys",
     "utils/string",
     "client/events/base-event",
     "client/actions/copy",
     "utils/flexbox",
     "client/extensions",
     "client/resourceinfo",
     "client/settings",
     "client/sourceinfo",
     "client/template",
     "client/templatetree",
     "client/formqueryadapter",
     "client/queryprofiler",
     "jquery",
     "utils/source_context_parser",
     "service/channels",
     "service/constrainedchannels",
     "model/properties",
     "model/tabs",
     "model/templateinfo",
     "model/tasks",
     "utils/jsonpath",
     "utils/browser",
     "utils/url",
     "utils/clone",
     "component!stack",
     "api/v2/applist",
     "utils/mustache",
     "utils/accessibility",
     "utils/lzma-helper",
     "client/client-config",
     "require",
     "utils/trace",
     "plugin-init",
     "utils/app",
     "api/v2/search",
     "utils/apptest",
     "client/client-extensions/builtin-client-extensions",
     "utils/settings_config",
     "client/environment",
     "utils/navigation-query-params",
     "bootstrap", //dont remove
     "client/client-extensions/extension-manager",
     "client/theme",
     "client/default-theme",
     "client/styles",
     "utils/object",
     "model/tree",
   ], function(
     _,
     Extensions,
     i18n,
     api,
     Common,
     Backbone,
     dom,
     keys,
     StringUtils,
     BaseEvent,
     CopyPath,
     flexbox,
     ClientExtensions,
     ResourceInfo,
     Settings,
     SourceInfo,
     Template,
     TemplateTree,
     FormQueryAdapter,
     QueryProfiler,
     $,
     sourceContextParser,
     Channels,
     ConstrainedChannels,
     PropertiesModel,
     Tabs,
     Templateinfo,
     Tasks,
     JSONPath,
     browser,
     url,
     clone,
     Stack,
     Applist,
     MustacheAdapter,
     Accessibility,
     LzmaHelper,
     clientConfig,
     require,
     Trace,
     pluginInit,
     AppUtils,
     Search,
     DefaultPersistedAppsCollection,
     BuiltinClientExtensions,
     SettingsConfig,
     Environment,
     NavigationQueryParams,
     bootstrap,//do not remove
     ExtensionManager,
     {Themeable, applyTheme, enforcePrivateIcons},
     {defaultTheme},
     {importStyles},
     MBObject,
     TreeModel
   ) {

  /*
  * Options
  * -------
  *
  * * enableRemoteSources: enable remote sources configured for client service (DEFAULT: true)
  * * enableProfile: enable the profile of the user (DEFAULT: false)
  * * enableSourceInfo: enable the ... (DEFAULT: ???)
  * * enableUserSourceInfo: enable the ... (DEFAULT: ???)
  *                                     ATTENTION: this can be security and performance relevant
  *                                     (e.g. Microsoft Exchange primary mailbox
  *                                     restriction)
  * * disableUserSourceInfo: don't load user specific source info. *deprecated*, use enableUserSourceInfo instead
  * *
  *
  * * queryURLParameter: name of parameter used for starting queries, default: query
                         e.g. http://www.example.com/?query=test starts a search for test
  *
  * * datasourcesNameOrder: order of data sources by name, overrules datasourcesCategoryOrder, e.g. ["MyExchange", "M:"]
  *                         missing values are sorted in default order
  * * datasourcesGroupByCategory: group data sources by category (DEFAULT: true)
  * * datasourcesCategoryOrder: order of categories, e.g. ["Web", "Microsoft Exchange"]
  *                             missing values are sorted in default order
  * * updateTitle: update the document title after searching (DEFAULT: false)
  * * titleTemplate: a template for the document title, will be used when updateTitle is enabled.
  *                  available properties: computing, i18n, stackTitle and unparsedUserQuery
  *                  (DEFAULT: "{{#unparsedUserQuery?}}{{unparsedUserQuery}} - {{/unparsedUserQuery?}}" + document.title + "{{#computing?}} ...{{/computing?}}")
  * * enableImmediateDisplayOfFederatedResults: when federating, display results of each data source immediately, this doesn't guarantee global order of results (DEFAULT: false)
  * * traceContextTokenCallback: callback returning an app.telemetry context token to attach for the current action, callback arguments: action ... one of (suggest, search, nextPage, filter)
  *
  * Events
  * ------
  *
  * * ajaxError: triggered, if an error occurs on any channel. Arguments: channel, response
  *
  * Public API
  * ----------
  *
  * * getUserConstraints(): gets the currently set user constraints, e.g. like filters
  * * setUserConstraints(userConstraints, options): restores the userConstraints. You should use the userConstraints returned by **getUserConstraints** (triggers a change on the search model)
  * * getUnparsedUserQuery(): gets the query entered by the user as a string
  * * setUnparsedUserQuery(unparsedUserQuery, options): sets the user query to the given string (triggers a change on the search model)
  */

  

  /**
    * @static
    * @module client/application
    * @typedef ApplicationDefinition
    * @memberof client/application
    * @type {Object}
    *
    */
  var ApplicationDefinition = {};

  /**
    * Application API.
    *
    * @exports client/application
    */

  var isWebpack = true;

  // jQuery will convert %20 to "+". This should stop the converting process while ajex calls 
  $.ajaxSettings.processData = false;

  // Disables JSON-to-JSONP promotion in jQuery to prevent potential XSS vulnerabilities (old jquery version)
  $.ajaxSettings.jsonp = false;

  var Application = function (options) {
    this.initTelemetryIfNeeded(options);
    
    var args = arguments;

    if (isWebpack) {
      initAppWebpack(this, options, pluginInit, args)
    } else {
      initAppRJS(this, options, pluginInit, args)
    }
  };

  // USef for legacy r.js build
  function initAppRJS(appInstance, options, pluginInit, args) {
    if (options && options.parentApplication) {
      appInstance._initialize.apply(appInstance, args);
    } else {
      pluginInit.loadPlugins.then(function(appConfig) {
        if (args.length > 0) {
          args[0] = Object.assign({}, args[0], { appConfig });
          console && console.warn && console.warn("Using external appConfig: The provided application options have been merged with an external appConfig. Verify the configuration to ensure it matches your intended settings.");
        } else {
          // in case args is length === 0
          _.isFunction(args.unshift) &&  args.unshift({ appConfig });
        }
        appInstance._initialize.apply(appInstance, args);
      });
    }
  }

  function initAppWebpack(appInstance, options, pluginInit, args) {

    $(document).ready(function(){
      var styleElements = $('style') || [];

      _.each(styleElements, function(styleEl) {
        if($(styleEl).text().indexOf('mini-css-extract-plugin') !==-1) {
          $(styleEl).remove();
        }
      })
    })

    function initApp(appConfig) {
      if (args.length > 0) {
        args[0] = Object.assign({}, args[0], { appConfig });
        console && console.warn && console.warn("Using external appConfig: The provided application options have been merged with an external appConfig. Verify the configuration to ensure it matches your intended settings.");
      } else {
        // in case args is length === 0
        _.isFunction(args.unshift) && args.unshift({ appConfig });
      }
      appInstance._initialize.apply(appInstance, args);
    }

    if (options && options.parentApplication) {
      appInstance._initialize.apply(appInstance, args);
    } else {
      pluginInit
        .loadPlugins()
        .then(function(appConfig) {
          var initialLang = (typeof document !== "undefined" && document.documentElement.lang) || "en-US";
          if (initialLang !== "en-US") {
            i18n.setLocale(initialLang, function() {
              initApp(appConfig);
            });
          } else {
            initApp(appConfig);
          }
        })
        .catch(error => {
          console.error("Failed to load appConfig:", error);
          // Fallback: initialize without appConfig
          const initialLang = (typeof document !== "undefined" && document.documentElement.lang) || "en-US";
          if (initialLang !== "en-US") {
            i18n.setLocale(initialLang, () => initApp({}));
          } else {
            initApp({});
          }
        });
    }
  }

  /**
   * @typedef Application
   * @memberof client/application
   * @type {Object}
   */

  /**
   * Register a application using the submitted definition.
   * @property {string} titleTemplate  For the title, a mustache template can be saved in order to display the query (unparsedUserQuery), the title of the current stack element (stackTitle) and the status, e.g. if the search is currently being performed (computing).
   * @property {bool} updateTitle If a search should start during initialization, when restrictions are stored? Values: true, false, default value: true
   * @property {bool} datasourcesGroupByCategory Display data sources grouped according to data source category. Values: true, false.  Default value: true
   * @property {bool} startSearch  If a search should start during initialization, when restrictions are stored? Values: true, false, default value: true
   * @property {string} queryURLParameter Name of the URL parameters for search terms (for example, opening the page http://www.example.com/?query=test will start a search for test). Default: query
   * @property {bool} enableRemoteSources activates registered federated data sources in the configuration. Values: true, false, default value: true
   * @property {bool} enableProfile activates the user profile. Values: true, false, default value: false
   * @property {bool} loginAsError Login requests are treated as errors. No login is displayed. Values: true, false, default value: false
   * @property {bool} enableImmediateDisplayOfFederatedResults when federating, display results of each data source immediately, this doesn't guarantee global order of results. Values: true, false, default value: false
   * @property {number} mesKeyBoostingFactor
   * @property {number} propertyBoostingFactor
   * @proeprty {bool}   templateResultsEnableAnswers
   * @example
   new Application({
        loginAsError: true,
        startSearch: true,
        enableProfile: false,
        enableSourceInfo: false,
        enableUserSourceInfo: false,
        updateTitle: true,
        linkOpenTarget: "_self",
        queryURLParamaeter: "unused",
        enableImmediateDisplayOfFederatedResults: false
      });
  */

  Application.extend = Backbone.Model.extend;
  Application.scriptLocation = ResourceInfo.scriptLocation;

  _.extend(Application.prototype, Backbone.Events, {
      scriptLocation: Application.scriptLocation,
      api: api,
      destroyed: false,

      _initialize: function (options) {
        var that = this,
          parentOptions = {},
          options = _.extend({appFragmentJson: null, searchParams: null}, options || {});

        this._id = _.uniqueId('app_');

        if (options.parentApplication) {
          parentOptions = _.clone(options.parentApplication.options || {});
        }

        this.options = _.extend({
          editing: false,
          locale: "en-US",
          lastTriggeredActionName: null,
          themeDescriptor: {},
          useShadowRoot: false,
          disableTheme: false,
        }, parentOptions, options);

        if (options.parentApplication && _.isFunction(options.parentApplication.getClientExtensions)) {
          this.clientExtensions = options.parentApplication.getClientExtensions();
        } else {
          this.clientExtensions = new BuiltinClientExtensions(this,
                                                              this.options.clientExtensionsProvider,
                                                              {persistedResourcesAppFragmentStoreCollection: this.options.experiementalPersistedResourcesAppFragmentStoreCollection, experimentalBuiltinModules:this.options.experimentalBuiltinModules, enableBuiltinModule: this.options.enableBuiltinModule});
        }

        if (options.parentApplication && _.isFunction(options.parentApplication.getClientAIExtensions)) {
          this.clientAIExtensions = options.parentApplication.getClientAIExtensions();
        } else if (options.clientAIExtensionsProvider)  {
          this.clientAIExtensions = options.clientAIExtensionsProvider.getAIExtensions({});
        }

        
        function moveNodes(srcEl, destEl) {
          var existingNodes = [];
          // move exsiting elements into the shadow root.
          for (var i = 0; i < srcEl.childNodes.length; ++i) {
            existingNodes.push(srcEl.childNodes[i]);
          }
          for (var i = 0; i < existingNodes.length; ++i) {
            destEl.appendChild(existingNodes[i]);
          }
        }

        function wrapInShadowRoot(rootEls) {
          var rootEl = _.isObject(rootEls) ? rootEls : rootEls[0];
          if (rootEl.shadowRoot) {
            return rootEl.shadowRoot;
          }
          var shadowRoot = rootEl.attachShadow({mode: "open"});
          return shadowRoot;
        }

        function patchJQueryInit(app) {
          app.shadowRootJQuery = $(app.shadowRoot);
          app.origJQueryInit = $.fn.init;
          app.patchedJQueryInit = function(selector, context, root) {
            if (_.isString(selector)) {
              if (!selector.match(/^body|meta|head.*/)) {
                root = app.shadowRootJQuery;
              }
            }
            return new app.origJQueryInit(selector, context, root);
          }
          $.fn.init = app.patchedJQueryInit;
        }

        this.rootEls = this.options.rootEls || this.options.rootEl || document.body; 

        // only use shadowRoot if parent does not yet already use shadowroot        
        if (this.options.useShadowRoot && !parentOptions.useShadowRoot) {

          var rootEl = this.rootEls;
          if (_.isArray(rootEl)) {
            rootEl = (rootEl.length == 1) ? rootEl[0] : null;
          }

          function getEditorRootEl(containerEl) {
            const elContent = containerEl.querySelector(".mb-editor-content .right .ss-infopairing-box-full")
            // Fabasoft prefixed the class with "ss" and it breaks our style
            elContent && elContent.classList && elContent.classList.add("infopairing-box-full")
            return elContent;
          }
          
          // only do shadow dom for containerEl if it contains rootEl
          if (this.options.containerEl && rootEl && !this.options.containerEl.contains(rootEl)) {
            var editorRootEl = getEditorRootEl(this.options.containerEl);
            if (editorRootEl) {
              this.rootEls = editorRootEl;
              rootEl = editorRootEl;
            }
          }
          
          function wrapAndApplyStyles(app, outerEl, shadowRootProfile /*"themed"|"workplace"*/) {
            app.shadowRoot = wrapInShadowRoot(outerEl);
            if (shadowRootProfile == "workplace") {
              importStyles(app);
            } else {
              // TDOO profile specific 
              app.importStylesLink(Application.scriptLocation + "../css/v2/adapted-themed.css");
            }
            if (_.isFunction(app.options.afterWrapInShadowRootCallback)) {
              // style importing is done either via app.importStylesLink or app.importStylesText
              app.options.afterWrapInShadowRootCallback(app, shadowRootProfile);
            }            
            // Future: app.importStylesLink(Application.scriptLocation + `../css/v2/adapted-${shadowRootProfile}.css`);            
            app.importFontawesomeFonts();
            patchJQueryInit(app);
            var el = document.createElement("div");
            el.classList.add("mb-shadow-container");
            app.shadowRoot.appendChild(el);
            moveNodes(outerEl, el);
            return el;
          }

          var shadowRootProfile = this.isInsideWorkplace() ? "workplace" : "themed";
          
          if (this.options.containerEl && (!rootEl || this.options.containerEl.contains(rootEl))) {
            this.options.containerEl = wrapAndApplyStyles(this, this.options.containerEl, shadowRootProfile);
          }
          // should that be in the TemplateTree
          else if (rootEl == null) {
            console.warn("Failed to use shadowRoot with multiple rootEls");
          }
          else if (this.options.containerEl && !rootEl.contains(this.options.containerEl)) {
            console.warn("Failed to use shadowRoot with dijsoined rootEl and containerEl");
          }
          else {
            var effectiveRoot = _.isObject(this.rootEls) ? this.rootEls : this.rootEls[0];
            this.rootEls = wrapAndApplyStyles(this, effectiveRoot, shadowRootProfile);
          }
        } else if(options.parentApplication && options.parentApplication.shadowRoot){
          this.shadowRoot = options.parentApplication.shadowRoot
        }

        if (options.parentApplication && options.parentApplication.getThemeDescriptorModel() && !this.options.disableTheme) {
          // clone to bind this.application inside the extensionmanager to the application.
          this.themeable = options.parentApplication.themeable;
        }
        else { // if (this.options.themeDescriptor) {
          var effectiveThemeDescriptor = defaultTheme;

          if (this.options.appConfig && !_.isEmpty(this.options.appConfig) && this.options.appConfig.mindbreezeThemeDescriptor) {
            enforcePrivateIcons(effectiveThemeDescriptor,this.options.themeDescriptor);
            effectiveThemeDescriptor = MBObject.merge(effectiveThemeDescriptor ,this.options.appConfig.mindbreezeThemeDescriptor);
          }

          if (this.options.themeDescriptor && !_.isEmpty(this.options.themeDescriptor)) {
            enforcePrivateIcons(effectiveThemeDescriptor,this.options.themeDescriptor);
            effectiveThemeDescriptor = MBObject.merge(effectiveThemeDescriptor ,this.options.themeDescriptor);
          }

          var themeContainerEl = that.options.containerEl || this.getRootDomEl();
          this.options.styleVarPrefix = "mindbreeze";
          if(!this.options.disableTheme){
            this.themeable = new Themeable({ el: themeContainerEl, themeDescriptor: effectiveThemeDescriptor, selector: "base", prefix: this.options.styleVarPrefix, useShadowRoot: this.options.useShadowRoot});
          }
        }

        this.initializeTraceContextTokenCallback();

        if ( typeof this.options.enableSourceInfo !== "undefined" ) {
          if ( this.options.enableSourceInfo !== false ) {
            this.options.enableSourceInfo = true;
          }
        } else {
          this.options.enableSourceInfo = true;
        }

        if ( this.options.enableSourceInfo === true ) {
          if ( typeof this.options.enableUserSourceInfo !== "undefined" ) {
            if ( this.options.enableUserSourceInfo !== false ) {
              this.options.enableUserSourceInfo = true;
            }
          } else {
            this.options.enableUserSourceInfo = true;
          }
        } else {
          this.options.enableUserSourceInfo = false;
        }

        this.options.useAvailablePropertiesAsFilters = this.useAvailablePropertiesAsFilters();

        if (this.options.useMessageFrameForNonBuiltinSources !== false) {
          this.options.useMessageFrameForNonBuiltinSources = true;
        }

        this.rootElsClone = this.options.rootEls || this.options.rootEl || document.body.cloneNode(true);

        this.setHighContrastClassIfIsEnabled();

        this.options.containerEl = this.options.containerEl || document.body;

        this.resolveTemplateReferences(this.rootEls);

        this.options = _.extend({}, this.getOptionsFromAttributes(this.rootEls), this.options);


        this.formqueryadapter = new FormQueryAdapter();
        this.jsonPath = JSONPath;
        this.models = {};
        this.views = _.extend({}, BaseEvent);

        if (this.options.parentApplication) {
          this.parentApplication = this.options.parentApplication;
          this.parentApplication.on("destroy", function () {
              this.parentApplication.off(null, null, this);
              this.destroy();
            }, this);

          // remove reference from parent...
          delete this.options.parentApplication;
        }
        // take channels form parent application unless overwritten
        if (!this.parentApplication || options.sources || options.channels) {
          this.initChannelOptions();
          this.themeVersionCheck();

          var channels = this.getChannelList(this.options);
          // init
          var mappedSourcesToChannels = AppUtils.mapSourcesToChannels(this.options, SourceInfo.builtinSources, channels);
          
          if (this.options.actionsSeparator) {
            this.options.mustacheListSerializationRules = this.options.mustacheListSerializationRules || [];
            this.options.mustacheListSerializationRules = [
              { namePattern: "actions", separator: this.options.actionsSeparator }
            ].concat(this.options.mustacheListSerializationRules);
          }
          
          this.models.defaultChannels = new Channels(mappedSourcesToChannels.builtInChannels, this.channelOptions);

          this.models.channels = new ConstrainedChannels(mappedSourcesToChannels.applicationChannels, this.channelOptions);
          var applists;
          this.models.applists = applists = new Applist.Applists();
          applists.each(this.listenToChannelChanges, this);
          this.models.applists.on("add", this.listenToChannelChanges, this);
          this.models.profile = this.api.getProfile.createModel(this.models.defaultChannels);
          this.models.sourceInfo = this.api.sourceInfo.createModel(this.models.channels);
          this.models.userSourceInfo = this.api.userSourceInfo.createModel(this.models.channels);

          this.models.topMenu = new Backbone.Collection();
          this.models.topMenu.comparator = "weight";
          this.initializeTopMenu();

          this.models.suggestResults = new Backbone.Model();

          this.models.relevanceItems = new Backbone.Collection();

          // this.models.personalization = this.api.personalization.createModel(this.models.channels);
          this.models.stack = new Stack.Model();
          this.models.stack.set("application", this);

          this.models.tasks = new Tasks();

          this.models.searchSettings = new Backbone.Collection();
          this.listenTo(this.models.searchSettings, "add", function(model) {
            // enable settings by default
            if (model.get("checked") === undefined) model.set("checked", true);
          });

          if (this.isPersonalizationAvailable() ) {
            this.models.searchSettings.add({
              key: "settings.search.disablePersonalization",
              label: "settings_search_personalized_results"
            });

            Settings.add({
              name: "search",
              module: "client/searchsettings"
            });
          }

          if (this.options.enhancedPDFPreview === undefined) {
            // If not set, default is FALSE
            this.options.enhancedPDFPreview = clientConfig.getEnhancedPDFPreview();
          }
        } else {
          this.models = _.extend({}, this.parentApplication.models, this.models);
          this.models.tabs = null; // unconditionally initialized in this.initialize later
          this.queryProfiler = new QueryProfiler({application:this, parentProfiler: this.parentApplication.queryProfiler});
        }
        this.channels = this.models.channels;
        this.channels.on("fail", function () {
            that.triggerAjaxError.apply(that, arguments);
        });

        if (options.parentApplication && options.parentApplication.extensionManager) {
          // clone to bind this.application inside the extensionmanager to the application.
          this.extensionManager = new ExtensionManager(this, {parent: options.parentApplication.extensionManager});
        }
        else {
          this.extensionManager = new ExtensionManager(this, {extensionsConfig: this.options.extensions || {}});
        }
        
        this.initialize(this.options.callback);


        if (!this.options.searchParams) {
          this.options.searchParams = new URLSearchParams(
            this.parentApplication ? "" : window.location.search
          );
        }
        
        if (this.options.isParamsUpdateRequired && !this.parentApplication) {
          this.listenTo(this.models.search, 'change', function() {
            const url = new URL(window.location);
            var queryString = this.serializeSearchModelToURLParamsString();
            url.search = queryString;
            history.replaceState(null, '', url.href);
          }.bind(this));


          window.addEventListener('popstate', function() {
            this.models.stack.popToApplication(this);
            document.activeElement.blur();
          }.bind(this));
        }
        that.options.extensions && that.options.extensions['mindbreeze.360'] &&  that.trigger('initialize360');
      },

      initTelemetryIfNeeded: function(options) {
        if (!options || (!options.parentApplication && !options.disableTelemetry)) {
          var channels = this.getChannelList(options);
          var mappedSourcesToChannels = AppUtils.mapApplicationSources(options, channels);
          if (!mappedSourcesToChannels.length) {
            console.warn('Telemetry could not be initialized, no default channel found');
            return;
          }
          var defaultChannelUrl = mappedSourcesToChannels[0].url;
          Trace.initAppTelemetryEnvUrl(options, defaultChannelUrl);
          Trace.activate(true);
        }
      },

      getChannelList: function(applicationOptions) {
        if (applicationOptions.sources) {
          return   applicationOptions.sources;
        } else if (applicationOptions.channels) {
          return applicationOptions.channels;
        }
       return SourceInfo.builtinSources;
      },

      isInsideWorkplace: function(){
        return this.options.extensions && this.options.extensions["mindbreeze.ai-assistant"];
      },
      updateSearchModelFromQueryString: function () {
        var urlQueryString = url.getQueryParam(window.location.search, this.options.queryStringURLParameter);
        if (urlQueryString) {
          var activeElement = document.activeElement;
          var reactivate = this.models.search.isActivated();
  
          var result = LzmaHelper.getRequestFromQueryURLParam(urlQueryString, this.options.queryStringLimit);
          if (result.validated) {
            var request = result.request;
            request.user = StringUtils.parsejQueryParamConstraints(request.user);
            document.activeElement.blur();
            this.models.search.deactivate();
  
            if (request.selectedTabName) {
              this.changeView({ name: request.selectedTabName });
            }
            var searchParams = {
              orderby: request.orderby,
              order_direction: request.order_direction,
              summarize_by: request.summarize_by,
            };
  
            Object.keys(searchParams).forEach(function(key) {
              this.models.search.set(key, searchParams[key]);
            }, this);
            if (request.source_context) {
              var source_context = sourceContextParser.parseInServerFormat(
                request.source_context,
                request.selectedTabName
            );

            if (source_context.constraints.view) {
                source_context.constraints.view.expandable =  true;
                source_context.constraints.view.id =  'view';
              }
              this.models.search.set("source_context", source_context);
            }
  
            this.models.search.input.set("user", request.user);
            if (reactivate) this.models.search.activate();
            document.activeElement = activeElement;
          }
        }
      },

      initChannelOptions: function() {
        var channelOptions = {};
        channelOptions.crossDomainAjax = this.options.crossDomainAjax || {};
        channelOptions.ajaxOptions = this.options.ajaxOptions || {};
        channelOptions.ajaxOptions.requestTimeoutInMs = {
          "export": 0
        };

        if (window && window.location) {
          channelOptions.referer = window.location.toString();
        }

        if (this.options.useMessageFrameForNonBuiltinSources) {
          channelOptions.useMessageFrameForNonBuiltinSources = this.options.useMessageFrameForNonBuiltinSources;
        }

        channelOptions.loginAsError = this.options.loginAsError || false;

        if (channelOptions.crossDomainAjax.onLoginAsErrorTreat403as401 === undefined) {
          channelOptions.crossDomainAjax.onLoginAsErrorTreat403as401 = true;
        }

        if ( ! _.isFunction(channelOptions.crossDomainAjax.treatBasicAuth401as403ForBrowser)) {
          channelOptions.crossDomainAjax.treatBasicAuth401as403ForBrowser = function (browserName) {
            return browserName.toLowerCase() === 'safari';
          }
        }

        if (this.options.sessionDescription) {
          channelOptions.sessionDescription = this.options.sessionDescription;
        }
        if (this.options.apiRequestHeaders) {
          channelOptions.headers = this.options.apiRequestHeaders;
        }

        if (this.options.applicationId === undefined) {
          this.options.applicationId = "Default Application";
        }

        // MMC Ajax Timeout option is used for search only.
        var ajaxRequestTimeoutInMsConfig = clientConfig.getAjaxRequestTimeoutInMs();
        if (ajaxRequestTimeoutInMsConfig !== null) {
          channelOptions.ajaxOptions.requestTimeoutInMs['search'] = ajaxRequestTimeoutInMsConfig;
        }

        // Map API methods custom timeouts to milliseconds and also genericFallbackTimeout
        if (channelOptions.ajaxOptions.requestTimeoutInSec !== undefined) {
          _.each(channelOptions.ajaxOptions.requestTimeoutInSec, function(timeoutValueInSec, key) {
            channelOptions.ajaxOptions.requestTimeoutInMs[key] = timeoutValueInSec * 1000;
          });
        }

        this.queryProfiler = new QueryProfiler({
          application: this,
          profilerSettings: this.options.profilerSettings,
          enablePersonalization: this.isPersonalizationAvailable(),
          personalizationQueryContextProperties: this.options.personalizationQueryContextProperties
        });

        channelOptions.requestTransformers = [this.queryProfiler.createRequestTransformer(), this.setRequestApplicationOptions()];
        channelOptions.application = this;

        // If application option not defined use the one from <meta>
        if (this.options.useLegacyMessageFrameChannel === undefined) {
          this.options.useLegacyMessageFrameChannel = clientConfig.getUseLegacyMessageFrameChannel();
        }

        channelOptions.useLegacyMessageFrameChannel = this.options.useLegacyMessageFrameChannel;
        this.channelOptions = channelOptions;
      },

      registerResultPropertiesEnrichmentHandlerFactoryV1: function(factory, priority) {
        if (this.clientExtensions) {
           this.clientExtensions.registerResultPropertiesEnrichmentHandlerFactoryV1(factory, priority);
        }
      },

      unregisterResultPropertiesEnrichmentHandlerFactoryV1: function(factory) {
        if (this.getClientExtensions()) {
          if (this.models && this.models.search && _.isFunction(this.models.search.trigger)) {
            this.models.search.trigger('dispose');
          } 
          this.getClientExtensions().unregisterResultPropertiesEnrichmentHandlerFactoryV1(factory)
        }
      },

      setRequestApplicationOptions: function () {
        var that = this;
        return function (channel, request, options) {
          if (request.path == "search") {
            if (that.options.disableExternalContextualization) {
              request.disable_external_contextualization = true;
            }
          }
          return request;
        }
      },

      importStylesLink: function(href) {
        if (!this._importedStyleNodes) {
          this._importedStyleNodes = [];
        }
        var parentNode = this.shadowRoot ? this.shadowRoot : document.head;
        var linkEl = document.createElement("link");
        linkEl.setAttribute("href", href);
        linkEl.setAttribute("rel", "stylesheet");
        if (parentNode.childNodes.length > 0) {
          parentNode.insertBefore(linkEl, parentNode.childNodes[0]);
        } else {
          parentNode.appendChild(linkEl);
        }

        this._importedStyleNodes.push(linkEl);
      },

      importFontawesomeFonts: function (){
        const fontawesome5Link = document.createElement('link');
        fontawesome5Link.rel = 'stylesheet';
        fontawesome5Link.href = Application.scriptLocation + "../css/v2/font-awesome-5-fonts.css" ;
        document.head.appendChild(fontawesome5Link);

        const fontawesomeLink = document.createElement('link');
        fontawesomeLink.rel = 'stylesheet';
        fontawesomeLink.href = Application.scriptLocation + "../css/v2/font-awesome-fonts.css" ;
        document.head.appendChild(fontawesomeLink);
      },

      importStylesText: function(styles) {
        if (!this._importedStyleNodes) {
          this._importedStyleNodes = [];
        }
        var parentNode = this.shadowRoot ? this.shadowRoot : document.head;
        var styleEl = document.createElement("style");
        styleEl.innerHTML = styles;
        if (parentNode.childNodes.length > 0) {
          parentNode.appendChild(styleEl, parentNode.childNodes[0]);
        } else {
          parentNode.appendChild(styleEl);
        }
        this._importedStyleNodes.push(styleEl);
      },
    
      getClientExtensions: function() {
        return this.clientExtensions;
      },

      getClientAIExtensions: function() {
        return this.clientAIExtensions;
      },
    
      getExtensionManager: function() {
        return this.extensionManager;
      },

      themeVersionCheck: function() {
        var supportedVersions = ['1.0'];

        if (_.isObject(this.options.theme)) {
          if (!this.options.theme.version || _.indexOf(supportedVersions, this.options.theme.version) === -1) {
            console.error('Application theme version property is required and the following versions are supported: ' + supportedVersions.join(','))
          }
        }
      },

      setHighContrastClassIfIsEnabled: function () {
        var enableHighContrast = browser.getURLParameter('enableHighContrast');
        if (!_.isUndefined(enableHighContrast)) {
          this.options.enableHighContrast = enableHighContrast == 'true';
        }
        if (this.options.enableHighContrast == true) {
          $(this.rootEls).addClass("mb-use-high-contrast");
        }
      },

      getRootDomEl: function() {
        return this.shadowRoot || document.body;
      },

      appendChildToRoot: function (previewEl) {
        var targetElement = this.shadowRoot || document.body;
        
        if (targetElement) {
          targetElement.appendChild(previewEl);
        }
      },

      useAvailablePropertiesAsFilters: function () {
        var useAvailablePropertiesAsFilters = browser.getURLParameter("available-filters");
        if (typeof useAvailablePropertiesAsFilters !== "undefined") {
          useAvailablePropertiesAsFilters = useAvailablePropertiesAsFilters === "properties" ? true : false;
        } else if (typeof this.options.useAvailablePropertiesAsFilters !== "undefined" ) {
          if ( this.options.useAvailablePropertiesAsFilters !== false ) {
            useAvailablePropertiesAsFilters = true;
          } else {
            useAvailablePropertiesAsFilters = false;
          }
        } else {
          useAvailablePropertiesAsFilters = false;
        }

        return useAvailablePropertiesAsFilters;
      },

      isPersonalizationAvailable: function () {
        var availableInMetas = dom.getMetaContentFromMetaName("enablePersonalization");

        if (!_.isUndefined(this.options.enablePersonalization)) {
          // enabled via application
          return this.options.enablePersonalization;
        } else if (!_.isUndefined(availableInMetas)) {
          // enabled via meta-tag
          this.options.enablePersonalization = availableInMetas === "true" ? true : false;
          return this.options.enablePersonalization
        }

        return this.options.enablePersonalization = true;
      },

      initialize: function (callback) {
        var that = this;

        if (this.options.msalConfig) {
          this.aquireMSALToken(this.options.msalConfig);
        }

        this.initializeSourceInfo();

        this.appid = this.options.appid || window.location.protocol.replace(/:/, '') + window.location.host + window.location.port + window.location.pathname;

        this.options.queryURLParameter = this.options.queryURLParameter || "query";
        this.options.queryStringURLParameter = this.options.queryStringURLParameter || "queryString";
        this.options.searchURLParameter = this.options.searchURLParameter || "search";

        if (typeof this.options.enableRemoteSources === "undefined") {
          if (typeof this.options.loginAsError !== "undefined") {
            this.options.enableRemoteSources = !this.options.loginAsError;
          } else {
            this.options.enableRemoteSources = true;
          }
        }

        this.options.enableAccessibilityHandlers = this.options.enableAccessibilityHandlers !== false;

        try {
          this.initializeModels();
          if (_.isFunction(this.options.initializeModels)) {
            this.options.initializeModels(this);
          }
        } catch (error) {
          console.error("Please make sure there is no undefined value in your stack call! check the initializeModels callback for undefined or null values.")
        }
        
        this.detectBrowserFeatures();

        var estimatedCountisRequested = browser.getURLParameter("request-estimated-count") === "true";
        if (estimatedCountisRequested) this.sendPostMessageAfterLoadoutput();

        this.addClassNames(this.rootEls);

        var enableRelevanceInfo = browser.getURLParameter("relevance-info") === "true";
        if (enableRelevanceInfo) this.displayRelevanceInfo();

        this.settingsConfig = null;
        var initActionSettings = {};

        var exprAttributes = this.options.exprEnvironment || {};
        
        if (this.options.initAction) {
          if (this.options.initAction.args) {
            exprAttributes = _.extend({},
                                      exprAttributes,
                                      this.options.initAction.args);           
          }
          initActionSettings = this.options.initAction.settings;
        }

        this.exprEnvironment = new Environment({"application": this});
        if (!_.isEmpty(exprAttributes)) {
          this.exprEnvironment.pushFrame(exprAttributes);
        }
        this.settingsConfig = new SettingsConfig(initActionSettings);
        if(!this.options.editableContainerEl){
          // this.options.editableContainerEl = this.rootEls;
        }

        if (this.options.beforeTemplateTreeInit) {
          this.options.beforeTemplateTreeInit(this);
        }

        this.templateTree = new TemplateTree(this.rootEls,
                                             "searchroot",
                                             this.options.templateString,
																						 {application: this,
                                              settingsConfig: this.settingsConfig,
                                              appFragmentJson: this.options.appFragmentJson,
                                              appFragmentContainerEl: this.options.editableContainerEl});

        this.rootViewPromise = new Promise(function (resolve, reject) {
          const rootViewPromise = that.templateTree.initialize(that, that.models.search, function (errors) {
            that.searchModelInitialized(errors, callback).finally( function () {
              // application.execute is available
              if (that.options.enableAccessibilityHandlers) {
                that.accessibilityContainer = new Accessibility.Container(that.rootEls);
              }
              i18n.patchI18nAttributes();
              if (!that.parentApplication) {
                ClientExtensions.provide("after", "Application.initialize", that);
              }
              if (!that.parentApplication) {
                that.views.on("entity:annotation:mouse*", that.createOrRemoveEntityTooltip);
              }  
              resolve(rootViewPromise);
            });       
          });
        });
      },

      getThemeDescriptorModel: function () {
        return this.themeable && this.themeable.model;
      },

      hasThemeDescriptor: function() {
        return this.themeable && this.themeable.hasTheme();
      },
      getThemeProvider: function () {
        return this.themeable;
      },

		  getExprEnvironment: function() {
				var result = {};
				var that = this;
				var env = this.exprEnvironment.get();
				var keys = _.keys(env);
				return _.reduce(keys, function (result, key) {
					var val = env[key];
					if (_.isFunction(val)) {
						val = val(that);
					}
  				result[key] = val;
					return result;
				}, {});
			},

      createExprFunction: function(exprAsString) {
        return this.exprEenvironment.createExprFunction.apply(this.exprEnvironment, arguments);
      },

      applyExprFunction: function(exprFun) {
        return this.exprEnvironment.applyExprFunction.apply(this.exprEnvironment, arguments);
      },

      copyAnswerPropertyToClipboard: function(options, input) {
        var text = options.model.get("text").text;
        navigator.clipboard.writeText(text).then(function copyClipboardText () {
            options.eventTarget.classList.add("mb-property-copied");
            setTimeout(function timeout() {
              options.eventTarget.classList.remove("mb-property-copied");
            }, 1500);
        });
      },

      copyContentToClipboard: function(options) {
        var content = options.content;
        navigator.clipboard.writeText(content);
      },

      toggleAnswers: function (options) {
        var $clickedElm = $(options.event.target);
        var $parentElm = $clickedElm.closest(".mb-answers-container");
        if ($parentElm.hasClass("show-all-answers")) {
          $parentElm.removeClass("show-all-answers");
          $parentElm.find("button.accordion-button").attr("aria-expanded", "false");
        } else {
          $parentElm.addClass("show-all-answers");
          $parentElm.find("button.accordion-button").attr("aria-expanded", "true");
        }
        $parentElm.find("i[class^='icon-chevron']").toggleClass("icon-chevron-down icon-chevron-up");
      },

      createOrRemoveEntityTooltip: function(entityOptions) {
        var element = entityOptions.targetInfo;
        var event = entityOptions.eventName;
        var translatedEntityName = element.getAttribute('data-prop-label-translated');
        var tooltipStyle = element.getAttribute('data-tooltip-style');

        if (event === 'entity:annotation:mouseover') {
          var tooltipElement = $(element).find('.entity-tooltip');
          if (tooltipElement.length > 0 || element.className === 'entity-tooltip') {
            tooltipElement.innerText = translatedEntityName;
          } else {
            var tooltipElement = document.createElement('div');
            tooltipElement.className = 'entity-tooltip';
            tooltipElement.style = tooltipStyle;
            tooltipElement.innerText = translatedEntityName;
            element.appendChild(tooltipElement);
          }
        } else if (event === 'entity:annotation:mouseleave') {
          if (element.className === 'entity-tooltip') { // element is tooltip itself
            $(element).remove();
          } else {
            $(element).find('.entity-tooltip').remove();
          }
        }
      },

      sendPostMessageAfterLoadoutput: function() {
        var that = this;
        api.search.on("loadoutput", function(model, atts, options) {
          if (atts && atts.estimated_count !== undefined) {
            if (_.isFunction(that.options.handleSearchResponse)) {
              that.options.handleSearchResponse(atts);
              return;
            } else {
              window.parent.postMessage({
                'estimatedCount': atts.estimated_count
              }, "*");
            }
          }
        });
      },

      getTitle: function () {
        if (this.options.title) {
          return this.options.title;
        } else if (this.options.appFragmentJson && this.options.appFragmentJson.title) {
          return this.options.appFragmentJson.title;
        }
        return "";
      },
      
      aquireMSALToken: function(msalConfig) {
        var isLogginingIn = false;
        var username = msalConfig.username;

        var callbackQueue = [];
        var silentLoginRequest = {
          forceRefresh: false,
          loginHint: username
        };
        var msal = msalConfig.msal;
        if (!msal) {
          console.warn("msal not found - please require it in the Mindbreeze.require(['msal'], function(msal) {...})");
          return null;
        }
        var msalInstance = new msal.PublicClientApplication(msalConfig.msalConfig);

        function getAccount(instance) {
          var currentAccounts = instance.getAllAccounts();
          if (currentAccounts === null) return null;
          if (currentAccounts.length > 0) {
            return currentAccounts[0];
          }
          return null;
        }

        function logRequestFailedMessage(name, error) {
          console.error(name + " fail, please check the Microsoft identity platform authentication configuration", error);
        }

        function triggerQueueCallbacks(accessToken, error) {
          for(var i = 0; i < callbackQueue.length; i++) {
            callbackQueue[i](error, {'Authorization': 'Bearer ' + accessToken});
          }
          callbackQueue = [];
        }

        function attemptSsoSilent(url, callback) {
          if (isLogginingIn) {
            return;
          }

          isLogginingIn = true;

          msalInstance.ssoSilent(silentLoginRequest).then(function () {
            isLogginingIn = false;
            getAccessTokenSilent(url, callback, true);
          }).catch(function (error) {
            logRequestFailedMessage("getAccessTokenSilent", error);
            var accessTokenRequest = {
              scopes: msalConfig.scopes
            }

            msalInstance.acquireTokenPopup(accessTokenRequest).then(function (accessTokenResponse) {
              isLogginingIn = false;
              triggerQueueCallbacks(accessTokenResponse.accessToken);
            }).catch(function (error) {
              logRequestFailedMessage("acquireTokenSilent", error);
              msalInstance.loginRedirect({
                scopes: msalConfig.scopes,
                loginHint: username,
                state: window.location.href
              });
            });

          })
        }

        function getAccessTokenSilent(url, callback) {
          callbackQueue.push(callback);
          var instanceAccount = getAccount(msalInstance);
          // TODO Can we detect if instanceAccount is valid???
          if (instanceAccount) {
            msalInstance.acquireTokenSilent({
              account: instanceAccount,
              forceRefresh: false,
              scopes: msalConfig.scopes
            }).then(function (response) {
              triggerQueueCallbacks(response.accessToken);
            }).catch(function (error) {
              logRequestFailedMessage("acquireTokenSilent", error);
              attemptSsoSilent(url, callback);
            })
          } else {
            attemptSsoSilent(url, callback);
          }
        }

        this.options.ajaxOptions = this.options.ajaxOptions || {};
        var originalRequestHeadersAsync = null;
        if (this.options.ajaxOptions.requestHeadersAsync) {
          originalRequestHeadersAsync = this.options.ajaxOptions.requestHeadersAsync;
        }
        this.options.ajaxOptions.requestHeadersAsync = function(url, callback) {
          if (originalRequestHeadersAsync) {
            originalRequestHeadersAsync.apply(this, arguments);
          }
          getAccessTokenSilent(url, callback);
        };
      },

      initializeTraceContextTokenCallback: function () {
        var callback = this.options.traceContextTokenCallback;
        if (_.isFunction(callback)) {
          Trace.addSurroundingContextTokenCallback(callback);
          this.listenTo(this, "destroy", function () {
            Trace.removeSurroundingContextTokenCallback(callback);
          });
        }
      },

      hasQueryParams: function(url) {
        return url.includes('?');
      },

      initializeTopMenu: function () {
        var help_url = this.models.profile.get("help_url");

        function getProfileHelpUrl(userprofile) {
          var profile_url = userprofile.get("help_url")
          if (profile_url) {
            var helpMenuItemModel = this.models.topMenu.where({ name: 'help' });
            var lang = i18n.currentLocale() || "en";

            function changeHelpUrl() {
              var _lang = i18n.locale.toLowerCase().indexOf("de") >= 0 ? 'de' : 'en'
              profile_url = browser.replaceUrlParam(profile_url, "lang", _lang);


              helpMenuItemModel[0].set({
                'href': profile_url,
                'className': 'mb-menu-item',
                'translated_title': i18n('client_toolbar_help_label')
              });
            }

            i18n.listenTo(i18n, "change:locale", function() {
              changeHelpUrl();
            })

            if(lang.toLowerCase().indexOf("de") < 0) {
              lang = "en";
            }

            if (this.hasQueryParams(profile_url)) {
              profile_url = profile_url + "&mb-lang=" + lang;
            } else {
              profile_url = profile_url + "?mb-lang=" + lang;
            }

            if (_.isArray(helpMenuItemModel ) && !_.isEmpty(helpMenuItemModel)) {
              helpMenuItemModel[0].set({
                'href': profile_url,
                'className': 'mb-menu-item',
                'translated_title': i18n('client_toolbar_help_label')
              });
            }
            this.stopListening(this.models.profile, "change", getProfileHelpUrl);
            this.stopListening(i18n, "change", changeHelpUrl);
          }
        };

        if (!help_url) {
          var userprofile = this.models.profile;
          this.listenTo(userprofile, "change", getProfileHelpUrl);
        }

        this.models.topMenu.add({
          weight: 2,
          name: "settings",
          title: "client_settings",
          translated_title: i18n("client_settings"),
          className: "mb-menu-settings mb-menu-item",
          actionObject: '{"modal":{"id":"preferences"}}'
        });

        /*
         *  Username/Login/Logout
        */

        var loginAction = clientConfig.getLoginStatus(),
            logoutDisabled = clientConfig.getLogoutDisabled(),
            displayUsername = clientConfig.getDisplayUsername(),
            username = clientConfig.getUsername(),
            isAuthenticated = loginAction && loginAction.length > 0 && !_.isUndefined(loginAction),
            isLoggedIn = loginAction === "logout";

        if (isAuthenticated) {
          var menuObj = {
            className: "mb-menu-item",
            title: i18n(loginAction),
            actionObject: '{"' +  loginAction + '": {}}'
          };

          if (isLoggedIn && logoutDisabled) {
            menuObj = null;
          }

          if (displayUsername === "true" && username) {
            var submenu;
            if (menuObj) submenu = menuObj;

            // username pattern
            if (username.indexOf("@") > 0) {
              var nameMatch = username.match(/^([^@]*)@/);
              username = nameMatch ? nameMatch[1] : null;
            }

            if (submenu) {
              menuObj = {
                title: i18n(username),
                "subTitle": submenu.title,
                "subActionObject": submenu.actionObject
              }
            }
          }

          if (!menuObj && username) {
            menuObj = { title: i18n(username) };
          }

          if (logoutDisabled && displayUsername === "false") {
            menuObj = null;
          }

          if (menuObj) {
            menuObj.weight = 2;
            menuObj.name = "login";

            this.models.topMenu.add(menuObj);
          }
        }

        this.models.topMenu.add({
          weight: 3,
          name: "help",
          title: "client_toolbar_help_label",
          translated_title: i18n("client_toolbar_help_label"),
          className: "hide",
          href: help_url
        });

      },


      displayRelevanceInfo: function() {
        var rootEl = $(this.rootEls).find("[data-template=results]");
        $('body').addClass("mb-show-relevanceInfo");
        rootEl.before('<div class="relevanceInfoSwitchbox"><h2 data-i18n="show_relevance_infos"></h2><label class="switch relevanceInfo"><input type="checkbox" id="relevanceInfo" checked data-action-name="toggleRelevanceInfoTemplate"><span class="slider round"></span></label></div>');

        this.toggleRelevanceInfoTemplate();
        $('<div data-template="table" data-edittable="true" data-appendonscroll="true" data-enabledumping="true" data-allowExport="false" data-properties="icon,title,relevance_order,group,mes:relevanceinfo.recency,mes:relevanceinfo.tf,mes:relevanceinfo.tf_idf,mes:relevanceinfo.proximity,mes:relevanceinfo.percent_zone_boost,mes:relevanceinfo.percent_term_boost,mes:relevanceinfo.percent_document_boost,mes:relevanceinfo.percent_term_match,mes:relevanceinfo.percent_tf_idf,datasource/mes:key, extension" class="relevanceInfoTable"></div>').insertBefore(rootEl);

        window.addEventListener("message", _.bind(function(e) {
          if (e && e.data && e.data.name == "triggerSearch") {
            this.models.search.input.set("user", this.models.search.input.get("user"));
          }
        }, this), false);
      },

      showErrorAsAlert: function (id, message) {
        var alertModel = new Backbone.Model({
          id: id,
          message: message,
          level: 'error'
        });
        this.models.channels.addAlert(alertModel);
      },

      triggerSearchAfterError: function () {
        var pagingAlertError = this.models.channels.alerts.get("paging_error");
        if (pagingAlertError) this.models.channels.alerts.remove(pagingAlertError);
        this.models.search.set(this.models.search.input.get());
      },

      toggleRelevanceInfoTemplate: function() {
        var resultTemplate = $(this.rootEls).find("[data-template=results]");
        var tableTemplate = $(this.rootEls).find("[data-template=table]");

        var resultContainer = $(this.rootEls).find(".span9");
        var filterContainer = $(this.rootEls).find(".span3");

        var relevanceInfoAvailable = $('#relevanceInfo');
        if(relevanceInfoAvailable.attr('checked')) {
          $(this.rootEls).addClass("mb-relevance-info");
          resultTemplate.hide();
          tableTemplate.show();
          resultContainer.width("100%");
        } else {
          $(this.rootEls).removeClass("mb-relevance-info");
          resultTemplate.show();
          tableTemplate.hide();
          resultContainer.width("74.35897435897436%");
        }
      },

      initializeDialog: function () {
        var that = this;
        var remoteOrigin = window.parent !== window && document.referrer.replace(/(https?:\/\/[^\/]*).*/, "$1");

        $(this.rootEls).addClass("mb-dialog");

        if (remoteOrigin) {
          var sendToParent = function sendToParent (request) {
            JSON.stringify(window.parent.postMessage(request, remoteOrigin));
          };
          this.closeDialog = function (options) {
            sendToParent({id: "closeDialog", call: { name: "closeDialog" }});
          }
          $(window).on("keydown", function (e) {
              if (e.keyCode == 27) that.closeDialog();
          });
        }
      },

      resolveTemplateReferences: function (els) {
        function cloneRec(dest, src) {
          if (!src || !src.childNodes) return;
          for (var i = 0; i < src.childNodes.length; i++) {
            var node =  src.childNodes[i];
            var cloned = node.cloneNode(false);
            if (cloned.nodeName.toUpperCase() == "SCRIPT") {
              cloned.text = node.text;
            } else {
              cloneRec(cloned, node);
            }
            dest.appendChild(cloned);
          }
        }

        do {
          var $referencers = $(els).find("[data-template-refid]:not([data-template='search']):not([data-template='searchcontainer']):not([data-replaced])");
          $referencers.each(function () {
            var refid = this.getAttribute("data-template-refid"),
            el = document.getElementById(refid);

            if (el) {
              cloneRec(this, el);
            } else {
              this.innerHTML = "Template with id \"" + refid + "\" not found!";
            }
            this.setAttribute("data-replaced", "true");
          });
        } while ($referencers.length > 0);

      },
      
      getOptionsFromAttributes: function (els) {
        var schema = new Template.Schema({
            attributes: {
              "datasourcesGroupByCategory": {
                type: "boolean",
                "default": true,
                required: false
              },
              "datasourcesCategoryOrder": {
                type: "list",
                required: false
              },
              "datasourcesNameOrder": {
                type: "list",
                required: false
              },
              "enableImmediateDisplayOfFederatedResults": {
                type: "boolean",
                "default": false,
                required: false
              }
            }
        })
        if (!_.isArray(els)) {
          els = [els];
        }
        var options = _.extend.apply(_, _.map(els, function (el) {
          return new dom.AttributeModel(el, "data-").getCamelCase();
        }));

        return schema.parseAttributes(options);
      },

      detectBrowserFeatures: function () {
        if (browser.isMobileSafariPrivateMode()) {
          this.models.channels.addAlert({id: "localStorage", level: "info", message: i18n("info_mobile_safari_private_mode")})
        } else if (!browser.localStorageAvailable()) {
          this.models.channels.addAlert({id: "localStorage", level: "info", message: i18n("info_local_storage_not_available")})
        }
      },

      initializeModels: function () {
        this.createSearchModel();
        this.models.search.deactivate();
        if (this.queryProfiler) this.queryProfiler.registerSearchModel(this.models.search);
        if (!this.parentApplication && this.options.updateTitle) {
          // the template uses {{{value}}} since it is only used for the document title and we want to see the characters correctly
          this.options.titleTemplate = this.options.titleTemplate || "{{#stackTitle}}{{{stackTitle}}} - {{/stackTitle}}{{^stackTitle}}{{#unparsedUserQuery?}}{{{unparsedUserQuery}}} - {{/unparsedUserQuery?}}{{/stackTitle}}" + document.title + "{{#computing?}} ...{{/computing?}}";
          this.listenTo(this.models.search, "computing", function () { this.updateTitle(true) });
          this.listenTo(this.models.search, "computed", function () { this.updateTitle(false) });
          this.listenTo(this.models.stack, "change", function () { this.updateTitle(false) });
        }

        this.listenTo(this.models.search.input, "validated", function (model, valid) { this.updateValidityDependantEls("search", valid) });

        this.models.tabs = new Tabs([], {
          constraintsModel: this.models.search.input.submodel("source_context.constraints"),
          application: this
        });

        this.models.templateinfo = new Templateinfo({
            appid: this.appid
          },
          {
            mainpartBinding: this.models.search.submodel("source_context.constraints.view.name").input
        });
        this.models.images = new TreeModel();
      },

      getModel: function (modelName) {
        return this.models[modelName];
      },

      updateValidityDependantEls: function (model, validity) {
        $(this.rootEls).find("[data-enable-if-model-valid='" + model + "']").attr("disabled", !validity);
      },

      on: function(name, callback, context) {
        if (name == "ajaxError") {
          var app = this;
          var ctx = {context: context, callback: callback, channels: function () { return app.channels;} };
          if (!this._eventFilterMap) {
            this._eventFilterMap = {};
          }
          if (!this._eventFilterMap[name])
            this._eventFilterMap[name] = [];

          this._eventFilterMap[name].push({context: ctx, callback: Channels.ignoreSuccessiveErrorsCallback});
          return Backbone.Events.on.call(this,
                                         name,
                                         Channels.ignoreSuccessiveErrorsCallback,
                                         ctx);
        } else {
          return Backbone.Events.on.apply(this, arguments);
        }
      },

      off: function(name, callback, context) {
        if (!name) {
          this._eventFilterMap = {};
        }
        if (name == "ajaxError") {
          if (this._eventFilterMap && (callback || context)) {
            // find the corresponding callback
            if (this._eventFilterMap[name]) {
              var events = this._eventFilterMap[name];
              var newEvents = [];
              for (var i = 0; i < events.length; ++i) {
                var event = events[i];
                if ((!callback || callback == event.context.callback)
                    && (!context || context == event.context.context)) {
                  Backbone.Events.off.call(this, name, event.callback, event.context);
                }
                else {
                  newEvents.push(event);
                }
              }
              this._eventFilterMap[name] = newEvents;
            }
          }
        }
        else {
          return Backbone.Events.off.apply(this, arguments);
        }
        return this;
      },

      updateTitle: function (computing) {
        var model = new Backbone.Model({
              i18n: i18n.string,
              unparsedUserQuery: this.getUnparsedUserQuery(),
              computing: computing,
              stackTitle: StringUtils.stripHtml(this.models.stack.lastChild() && this.models.stack.lastChild().get("title"))
            }),
            mustache = new MustacheAdapter(this.options.titleTemplate);

        document.title = mustache.render(model);
      },

      initDatasourcesOrder: function () {
        var customOrderFunction,
            customSortFunction;

        if (this.options.datasourcesGroupByCategory) {
          customSortFunction = Common.getCompareFunction("PROPERTY", null, {
              criteriaPropertyName: "categories.id",
              subCriteria: {
                criteria: "PROPERTY",
                options: {
                  criteriaPropertyName: "name"
                }
              },
              mapKeyPropertyName: "name"
          });
          customOrderFunction = Common.getOrderFunctionByList(this.options.datasourcesCategoryOrder, "categories.id");
        }

        if (this.options.datasourcesNameOrder && this.options.datasourcesNameOrder.length > 0) {
          if (customOrderFunction) { // grouped
            customOrderFunction = Common.getOrderFunctionByList(this.options.datasourcesCategoryOrder, "categories.id",
                                    Common.getOrderFunctionByList(this.options.datasourcesNameOrder, "name"));
          } else {
            customOrderFunction = Common.getOrderFunctionByList(this.options.datasourcesNameOrder, "name");
          }
        }

        if (customOrderFunction) {
          if (customSortFunction) {
            customOrderFunction = Common.wrapOrderFunctionWithSort(customOrderFunction, customSortFunction);
          }

          this.models.sourceInfo.applyCustomOrder = customOrderFunction;
          this.models.userSourceInfo.applyCustomOrder = customOrderFunction;
        }
      },

      addClassNames: function (rootEls) {
        var classes = [],
            highContrastClass = Accessibility.highContrast.get();

        if (highContrastClass) {
          classes.push(highContrastClass);
        }

        if (flexbox()) {
          classes.push("mb-flexbox");
        }
        else {
          classes.push("no-flexbox");
        }

        if (browser.getURLParameter("embedded") === "true") {
          classes.push("mb-embedded");
        }
        if (browser.isTouchDevice()) {
          classes.push("mb-touch");
        }

        if (classes.length) {
          if (!_.isArray(rootEls)) {
            rootEls = [rootEls];
          }
          _.each(rootEls, function (el) {
            $(el).addClass(classes.join(" "));
          })
        }
      },

      setLocale: function(locale, callback) {
        var that = this;
        i18n.setLocale(locale, function(i18n) {
          that.options.locale = i18n.locale;
          if (callback) {
            callback(i18n);
          }
        });

      },

      selectFirstTab: function () {
        var firstTab = this.models.tabs && this.models.tabs.at(0),
            sourceContextConstraintsModel;

        if (firstTab && !this.options.retainViewSourceContextConstraints && firstTab.get("id") !== "emailalert") {
          this.changeView({
            model: firstTab
          });
        }
        else if (!this.options.retainViewSourceContextConstraints){
          sourceContextConstraintsModel = this.models.search.submodel("source_context.constraints");
          sourceContextConstraintsModel.unset("view", {silent:true});
          sourceContextConstraintsModel.dispose();
        }
      },

      initializeSourceInfo: function () {
        this.initDatasourcesOrder();
        var that = this;
        // only perform this if we own the sourceInfo
        if (this.options.enableSourceInfo && (!this.parentApplication || this.parentApplication.models.sourceinfo != this.models.sourceinfo)) {
          this.models.sourceInfo.update(null, function (model, error) {
            if (that.options.enableRemoteSources) {
              _.each(model && model.remote_sources, function (source) {
                var channel = {
                  url: source.location + "api/v2/",
                  channelType: "MessageFrameChannel"
                };

                if (source.options) {
                  channel.channelType =  source.options.channel_cors_disabled ? "MessageFrameChannel" :  "CrossDomainAjaxChannel";
                }

                that.models.channels.add(channel, that.channelOptions);
              });
            }
            if (that.options.enableUserSourceInfo) {
              // TODO: update sourceContext and allow searches
              that.models.userSourceInfo.update(null, function (model, error) { })
            }
          });

          this.models.channels.on("add change:enabled", function (channel, value) {
              var channel = [channel];
              if (value === false) { //disabled
                channel = null;
              }
              that.models.userSourceInfo.update(channel, function (model, error) { })
          });
          this.models.channels.on("remove", function () {
              that.models.userSourceInfo.update(null, function (model, error) { })
          });
        }
      },

      waitForDataSources: function(model, callback) {
        var that = this;
        const checkDataSources = function () {
          const dataSources = model.get('sources.data_sources');
          if (!_.isEmpty(dataSources)) {
            that.stopListening(model, "change:sources", checkDataSources);
            if (callback && typeof callback === 'function') {
              callback(dataSources);
            }
          }
        };
        checkDataSources()
        this.listenTo(model, "change:sources", checkDataSources);
      },
      
      handleQueryURLAsync: function(initialUserQuery, startSearch) {
        var that = this;

        var options = {
          requiresInitFromQueryParamsForAllParams: true
        }
        if (this.options.queryURLParameter) {
          options.querySearchParamName = this.options.queryURLParameter;
        }
        
        var allQueryParams = NavigationQueryParams.getAllQueryParamsFromSearchParams(this.options.searchParams, options) || [];
        this.models.search.deactivate();
          
        return NavigationQueryParams.triggerActionsFromQueryParamsAsync(allQueryParams, this).finally(function () {          
          var initalUserQueryIsSet = initialUserQuery != null;
          // `InputUserQuery` uses the `getUnparsedUserQueryPathAndSetDidChangeUserQuery` when setting the query
          NavigationQueryParams.updateSearchModelFromQueryParams(allQueryParams, that.models.search, that.getUnparsedUserQueryPath.bind(that));
          if (initialUserQuery) {
            that.setUnparsedUserQuery(initialUserQuery);
          }

          that.models.search.activate({silent: true});
          if (startSearch || initalUserQueryIsSet || allQueryParams.length > 0) {
            that.models.search.input.change({forceUIUpdate: true, triggerActionName: "queryURLParameter"})
          }
        });        
      },

      searchModelInitialized: function (errors, callback) {
        var that = this;

        $("body").on("click.mb-application", function () {
          that.closeMenus();
          $(".mb-popover-trigger").popover("destroy");
        });
        $("body").on("keydown.mb-application", function (e) {
          if (e.which === keys.esc) {
            that.closeMenus();
            $(".mb-popover-trigger").popover("destroy");
          }
        });
        
        this.selectFirstTab();

        var startSearch = this.options.startSearch;
        if (_.isUndefined(startSearch)) startSearch = true;
        var enableVoting = $('[data-template="results"][data-enable-voting=true]').length;

        if (enableVoting) {
          if (isWebpack) {
            Mindbreeze.require(["voting"]);
          }
          else {
            Mindbreeze.require(["component!voting"]);
          }
        }

        var urlQuery = this.options.initialUserQuery != null ? 
          this.options.initialUserQuery :
          browser.getURLParameter(this.options.queryURLParameter);
        // setup the state before the model is activated
        if (this.onTemplateTreeInitialized) {
          this.onTemplateTreeInitialized(errors);
        }
        if (this.prepareModels) {
          this.prepareModels(errors);
        }
        if (this.options.prepareModels) {
          this.options.prepareModels(this, errors);
        }

         // only perform this if we own the profile
         if (!this.parentApplication || this.parentApplication.models.profile != this.models.profile) {
          if (this.options.enableProfile) {
            this.listenTo(this.models.profile, "change", this._profileUpdated);
            this.models.profile.update();
          } else {
            this.models.profile.updated();
          }  
        }

        return this.handleQueryURLAsync(this.options.initialUserQuery, startSearch).finally(function () {
          //this.activateSearchAndOptionalTiggerQuery(startSearch,!!this.options.initialUserQuer);
          try {
            that.updateSearchModelFromQueryString.call(that)
          } catch (e) {
            that.showErrorAsAlert('savedsearches', i18n('unable_to_parse_querystring'));
          }

          that.initialized = true;
          if (errors) {
            that.failed = true;
            if (console && console.warn) {
              console.warn.apply(console, "Failed to initialize application.", errors);
            }
          }

          that.updateValidityDependantEls("search", that.models.search.input.validate());

          that.trigger("initialized", errors);
          if (urlQuery) {
            that.trigger("hasQueryURLParameterValue");
          }
          if (callback){
            callback(that);
          }
          that.trigger("afterApplicationCallback", errors);
        });
      },

      _profileUpdated: function () {
        var model = this.models.profile;
        Trace.setUserName(model.get("user_name"));
        this.models.applists.fetch({
          channels: model.get("app_list_urls"),
          channelOptions: this.channelOptions
        });
      },

      parseQueryExprToLabelMap: function (query) {
        var queries = query ? query.and || [query] : [],
          that = this;

      return _.reduce(queries, function (queryByName, part) {
        var props = _.keys(part),
            ok =  (props.length <= 2 && _.difference(props, ["label", "unparsed"]).length == 0) || part._name,
            label;

        if (ok) {
         label = part._name || part.label ||  "query";
         queryByName[label] = part;
        }

        return queryByName;
        }, {});
    },

    serializeLabelMapToQueryExpr: function (map) {
      return _.map(_.keys(map), function(key) {
          return map[key];
      });
    },

      setConstraint: function(constraint) {
        // workaround for skipping outer constraint 
        if (this.options.ignoreChannelsConstraint) {
          return;
        }
        this.channels.setConstraint(constraint);
      },

      getConstraint: function() {
        return this.channels.getConstraint();
      },

      setACLConstraint: function(constraint) {
        this.channels.setACLConstraint(constraint);
      },

      getACLConstraint: function() {
        return this.channels.getACLConstraint();
      },

      execute: function(callback) {
        if (this.destroyed) {
          throw new Error("Application already destroyed.");
        }
        if (!this.initialized) {
          this.once("initialized",
                    function(errors) {
                      // console.log("Deferred.");
                      callback(this);
                    },
                    this);
        }
        else {
          callback(this);
        }
      },

      queryViewByTemplateTypeAsync: function(templateType) {
        var that = this;
        return new Promise(function(resolve, reject) {
          if (!templateType) {
            return reject(new Error('queryViewByTemplateTypeAsync: templateType is required'));
          }

          try {
            that.execute(function() {
              if (!that.rootViewPromise) {
                return reject(new Error('queryViewByTemplateTypeAsync: rootViewPromise is not initialized'));
              }

              // Wrapping in Promise.resolve().catch(reject) ensures exceptions thrown inside
              // .then() propagate to the outer promise instead of being silently swallowed.
              Promise.resolve(that.rootViewPromise)
                .then(function() {
                  if (!that.templateTree) {
                    throw new Error('queryViewByTemplateTypeAsync: templateTree is not available');
                  }

                  var template = that.templateTree.queryTemplateByType(templateType);

                  if (!template) {
                    throw new Error('queryViewByTemplateTypeAsync: no template found for type "' + templateType + '"');
                  }

                  var instances = template.instances && template.instances.instances;

                  if (!instances || instances.length === 0) {
                    throw new Error('queryViewByTemplateTypeAsync: no instances found for template type "' + templateType + '"');
                  }

                  resolve(instances.at(-1));
                })
                .catch(reject);
            });
          } catch (err) {
            reject(err);
          }
        });
      },
    
      createSearchModel: function () {
        var modelOptions = {
          clientExtensions: this.getClientExtensions(),
          enableImmediateDisplayOfFederatedResults: this.options.enableImmediateDisplayOfFederatedResults,
        }

        var search = api.search.createModel(this.models.channels, modelOptions);

        var modelDefaults = {
          "content_sample_length": 300,
          "name": this.options.searchRequestName || browser.getURLParameter('searchRequestName') || 'default'
        };
        var defaults = _.extend(modelDefaults, this.options.modelDefaults && this.options.modelDefaults.search || {});

        this.setSampleTextMarkEntities(search);

        search.set(clone(defaults), {silent: true});
        this.models.search = search;
      },

      setSampleTextMarkEntities: function (search) {
        if (this.options.entity) {
          this.setSampleTextEntityOptions(search);
        } else {
          // legacy entity options
          this.setSampleTextMarkEntity('sampleTextMarkEntityTypes', search);
          this.setSampleTextMarkEntity('sampleTextMarkAllEntityTypes', search);
        }
      },

      setSampleTextEntityOptions: function (search) {
        if (!_.isUndefined(this.options.entity)) {
          var markAllEntityTypes = this.options.entity.markAllEntityTypes;
          var markEntityTypes = this.options.entity.markEntityTypes;
          var isDisabled = this.entitiesAreDisabledForFeature('sampleText');

          if (isDisabled === true) {
            // When disabled, always set mark_all_entities to false
            search.set(StringUtils.camelCaseToSnakeCase("sampleTextMarkAllEntityTypes"), false, { silent: true });
            return;
          }

          // priorize all entities before explicit entities from the options
          if (!_.isUndefined(markAllEntityTypes)) {
            if (_.isUndefined(markEntityTypes)) {
              // Wenn mark_all_entities is set without the rest, we want to set mark_all_entities
              search.set(StringUtils.camelCaseToSnakeCase("sampleTextMarkAllEntityTypes"), markAllEntityTypes, { silent: true });

            } else {
              // When mark_all_entities is set and mark_entities is set, we want to set both as given
              search.set(StringUtils.camelCaseToSnakeCase("sampleTextMarkAllEntityTypes"), markAllEntityTypes, { silent: true });
              search.set(StringUtils.camelCaseToSnakeCase("sampleTextMarkEntityTypes"), markEntityTypes, { silent: true });

            }
          } else if (!_.isUndefined(markEntityTypes)) {
            // When mark_entities is iset instead we want to set all_entities to false in addition
            search.set(StringUtils.camelCaseToSnakeCase("sampleTextMarkAllEntityTypes"), false, { silent: true });
            search.set(StringUtils.camelCaseToSnakeCase("sampleTextMarkEntityTypes"), markEntityTypes, { silent: true });
          }
        }
      },

      entitiesAreDisabledForFeature: function(key) {
        if (this.options.entity.disabled && !_.isUndefined(this.options.entity.disabled[key])) {
          return this.options.entity.disabled[key];
        }
        return null;
      },

      setSampleTextMarkEntity: function (key, search) {
        var entityOptions = this.options[key];
        if (!_.isUndefined(entityOptions)) {
          var data = this.getEntityValue(entityOptions, key);
          search.set(StringUtils.camelCaseToSnakeCase(key), data, { silent: true });
        }
      },

      getEntityValue: function (entitiesFromApplication, key) {
        if (!_.isUndefined(entitiesFromApplication)) {
          if (key === 'sampleTextMarkEntityTypes') {
            return entitiesFromApplication;
          } else if (key === 'sampleTextMarkAllEntityTypes') {
            return entitiesFromApplication === 'true' || entitiesFromApplication === true;
          }
        }
        return undefined;
      },

      setDefaultEditMode: function(channel, request, options) {
        if (request.path == "search" && channel && channel.id) {
          request.edit_mode = true;
        }
        return request;
      },

      edit: function() {
        var that = this;
        require(['client/editor'], function (Editor) {

          // Add a request transformer to prepare the requests from the designer
          if (that.models.channels && that.models.channels.options) {
            if (_.isArray(that.models.channels.options.requestTransformers)) {
              that.models.channels.options.requestTransformers.push(that.setDefaultEditMode);
            } else {
              that.models.channels.options.requestTransformers = [that.setDefaultEditMode];
            }
          }

          if (that.shadowRoot != null) {
            that.importStylesLink(Application.scriptLocation + "../css/v2/designer.css");
          }
          
          $("body").removeClass("mb-loading");
          _.extend(that, Editor.applicationAdditions);
          var startEditMode = function(that) {
            var editor = new Editor(that , function(editor){
              window.setTimeout(function() {
                editor.refresh();
              }, 500);
              that.editor = editor;
            });
            that.editing = true;
            that.trigger("edit");
            $("#edit-button").addClass("active");
          }
          setTimeout(startEditMode(that), that.options.editDebounce || 2000);
        });
      },

      exportResults: function(options){
        try {
                  localStorage.mbLastExport = JSON.stringify({
                    name: $(options.eventTarget).text(),
                    properties: options.properties
                  });
                  window.updateLastExport && window.updateLastExport();
        } catch (e) {
        /* ignore */
        }

        if (_.isString(options.properties)) {
          var re = /\s*,\s*/;
          options.properties = options.properties.split(re);
        }

        if (_.isString(options.excludeFromTranslation)) {
          var re = /\s*,\s*/;
          options.excludeFromTranslation = options.excludeFromTranslation.split(re);
        }

        this.pushStack({
          action: "exportView",
          "content": "<div data-template='exportview'></div>",
          "title": i18n("export_results"),
          "applicationOptions": {
            appendOnTableScroll: options.appendonscroll,
            exportformat: options.exportformat,
            excludeFromTranslation: options.excludeFromTranslation,
            retainViewSourceContextConstraints: true,
            initializeModels: function(app) {
              // this called before the search tree is initialized by templates
              // models still deactivated, so we can set it, without triggering search.
              var searchInput = app.parentApplication.models.search.input.toJSON();
              delete searchInput.max_page_count;
              delete searchInput.facets;
              searchInput.properties = _.reduce(options.properties, function(properties, p) { properties[p] = { formats: ["HTML", "VALUE"]}; return properties }, {});
              app.models.search.output.load({"available_properties":  app.parentApplication.models.search.get("available_properties")}, {silent: true});
              app.models.search.set(searchInput);
            }
          }
        });
      },

      exportView: function (options) {
        // TODO: cleanup (e.g. paging)0
        this.models.search.input.change();
      },

      getDefaultTemplateContentForAction: function(actionName) {
        if (actionName) {
          return "<div data-template='" + actionName.toLowerCase() + "' />";
        } else {
          return "";
        }
      },

      getPreviewView: function (callback) {
        var that = this,
            template = this.templateTree.getTemplateById("mb_preview") || this.templateTree.queryTemplateByType("preview");

        if (template && template.instances && template.instances.length) {
          return callback(template.instances.instances[0]);
        }

        if (this.parentApplication) {
          this.parentApplication.getPreviewView(function (previewView) {
            if (previewView) {
              callback.apply(this, arguments);
            } else {
              that.createPreviewView(callback);
            }
          });
        } else {
          this.createPreviewView(callback);
        }
      },

      // basic functionality to create an application.
      createApplication: function (options) {
        var appOptions = _.extend({}, options);
        delete appOptions.ApplicationConstructor;
        if (this.options.disableExternalContextualization != null && options.disableExternalContextualization != null) {
          appOptions.disableExternalContextualization = this.options.disableExternalContextualization;
        }
        appOptions.parentApplication = this;
        this.options.appFragmentJson = null;
        if (!appOptions.rootEl && !appOptions.rootEls) {
          appOptions.rootEl = document.createElement("div");
          appOptions.viewportElement = appOptions.rootEl;
        }
        if (appOptions.appFragmentJson) {
          appOptions.appFragmentJson = Object.assign({}, options.appFragmentJson)
          appOptions.appFragmentJson.bindings = Object.assign({}, appOptions.appFragmentJson.bindings, options.appFragmentJsonBindings || {})
        }
        if (appOptions.unparsedUserQuery) {
          var origCallback = appOptions.callback;
          appOptions.callback = function (app) {
            app.setUnparsedUserQuery(appOptions.unparsedUserQuery);
            if (origCallback) {
              origCallback(app);
            }
          }
        }

        const AppConstructor = options.ApplicationConstructor || Application;
        return new AppConstructor(appOptions);
      },

      launchApp: function (options) {
        return this.pushStack.apply(this, arguments);
      },

    
      createPreviewView: function (callback) {
        this.createView("preview", callback);
      },

      getOrCreateView: function (template, callback) {
        var view = this[template + "View"];
        if (view) {
          callback(view);
        } else {
          this.createView(template, callback);
        }
      },

      createView: function (template, callback) {
        var that = this,
            tmp = document.createElement("div");
        this.rootEls.appendChild(tmp)
        // the constractor in tempatetree.js needs application
        var tree = new TemplateTree(tmp, template, null, {application: this});

        tree.initialize(this, new Backbone.Model(), function () {
          var view = tree.rootNode.template.instances.instances[0]
          that[template + "View"] = view;
          callback(view);
        });
      },

    //createViewFromFragment: 

      removeConstraint: function (options) {
        var id = options.id || options.model.id || options.model.get && (options.model.get("description") || options.model.get("id")),
            userConstraintsModel = this.models.search.input.submodel("user.constraints");

        var idOrPath = id;
        try {
          idOrPath = JSONPath.parsePath(id);
        } catch (e) {
          // ignore
        }

        if (_.isArray(idOrPath) && idOrPath.length > 1) {
          var path = idOrPath;
          var elt = path.pop();
          userConstraintsModel.set(JSON.stringify(elt), undefined, {path: path, unset:true, silent:true});
          if (path.length > 1 && $.isEmptyObject(userConstraintsModel.get(path))) {
            userConstraintsModel.set(path[0], undefined, {unset:true, silent:true});
          }
          userConstraintsModel.change();
        }
        else {
          userConstraintsModel.unset(id);
        }
        userConstraintsModel.dispose();
      },

      subquery: function (query_expr) {
        delete query_expr.eventTarget;
        delete query_expr.model;
        delete query_expr.sender;
        delete query_expr.focused;
        delete query_expr.event;

        var id = query_expr.description || query_expr.id || _.uniqueId('q'),
            userConstraintsModel = this.models.search.input.submodel("user.constraints");

        id = this.sanitizePath(id);

        userConstraintsModel.set(null, query_expr, {path: [id]});
        userConstraintsModel.dispose();
      },

      /* actions */
      query: function (query_expr) {
        delete query_expr.eventTarget;
        delete query_expr.model;
        delete query_expr.sender;
        delete query_expr.focused;
        delete query_expr.event;

        var id = query_expr.description || query_expr.id || _.uniqueId('q');
        id = this.sanitizePath(id);
        id = "__queryaction__" + id;

        var user = {constraints: {} };
        user.constraints[id] = query_expr;
        this.models.search.input.set("user", user);
      },

      emptyModel: function (options) {
        var collection = options.model.get(options.path);
        collection.remove(collection.models);
      },

      destroyModel: function (options) {
        var model = options.model;
        model.trigger('destroy', model, model.collection, options);
      },

      extensionAction: function (options) {
        var action = Extensions.lookup(options.id);
        var target = options.eventTarget;

        if (action) {
          action({
            invokeInContext: options.invokeInContext
          });
        }
      },

      modal: function (options) {
        var activeElement = document.activeElement;

        $("#" + options.id).one('shown', function () {
          $(this).find("button").first().focus();
        }).modal();

        $("#" + options.id).one('hidden', function () {
          activeElement.focus();
        });
      },

      login: function () {
        var mashupLoginPath = '/mashup-login?resource=' + window.location.pathname + '';
        var mashupLoginURL = ResourceInfo.scriptLocation + '../..' + mashupLoginPath;

        if (this.options && this.options.loginUrl !== undefined) {
          var loginUrl = this.options.loginUrl;
          mashupLoginURL = loginUrl + mashupLoginPath;
        }

        window.open(mashupLoginURL, "_self");
      },

      logout: function () {
        var rootEls = this.rootEls;
        if (!_.isArray(rootEls)) rootEls = [rootEls];
        _.each(rootEls, function (el) {
          $(el).addClass("mb-logout");
        });

        var excluded = this.models.defaultChannels.at(0).get("url"),
            timeout = 0,
            channelsToLogout = this.models.channels.filter(function (channel) {
              return channel.get("url") !== excluded;
            });

        if (channelsToLogout && channelsToLogout.length > 0) {
          this.api.logout.cast(channelsToLogout);
          timeout = 3000;
        }
        var redirectLocation = excluded + this.api.logout.getLogoutPath();

        setTimeout(function () {
          window.location = redirectLocation;
        }, timeout);
      },

      toggleOpen: function (options) {
        var enabledSelector = options.enabledSelector;

        if (!enabledSelector || $(enabledSelector).is(":visible")) {
          $(options.eventTarget).toggleClass("mb-open");
        }
      },

      closeMenus: function (options) {
        var $group = options && options.eventTarget && $(options.eventTarget.parentNode);
        $(".mb-dropdown-toggle.open").not($group).removeClass("open").find(".dropdown-menu").remove();
      },

      openMenu: function (options) {
        var propertyId =  options.propertyId || $(options.eventTarget).parents('[data-id]').first().attr('data-id'),
            $group = $(options.eventTarget.parentNode),
            valueIndex = options.position || 0,
            summary = options.model.get("mes:summary"),
            property = options.model.get(propertyId) || _.find(_.isArray(summary) || !summary ? summary : [summary] , function (property) { return property.id === propertyId; }),
            actions = property && property.data && property.data.length > valueIndex && property.data[valueIndex].actions;

        if ($group.hasClass("open")) {
          $group.removeClass("open");
          $group.find(".dropdown-menu").remove();
          return;
        }

        // TODO: only once
        $group.append('<ul class="dropdown-menu">' + _.map(actions.data, function (action) {
            return '<li>' + action.html + '</li>';
        }).join("") + '</ul>');
        $group.addClass("open");
      },

      toggleDropdown: function (options) {
        $(options.eventTarget).dropdown('toggle');
      },

      setDidYouMean: function (options) {
        if (!options) return;
        var query = options.query,
            model = options.model;

        if (model.input.get("query")) {
          model.input.set("query", query);
        } else {
          var queryFieldInfo = this.formqueryadapter.queryField() || {path: []},
              userQueryPath = ["user", "query"].concat(queryFieldInfo.path);
          model.input.set(null, query, _.extend({}, options, {path: userQueryPath}));
        }
     },

     setNonMatchedTerm: function (options) {
      var nonmatchedTerm = options.eventTarget.innerText;
      var unparsedUserQuery = this.getUnparsedUserQuery();
      var termIsincludedInUnparsedUserQuery = StringUtils.isTermIncludedInString(unparsedUserQuery, nonmatchedTerm);
      if (termIsincludedInUnparsedUserQuery) {
        var quotedUnparsedUserQuery = StringUtils.quoteTermInString(unparsedUserQuery, nonmatchedTerm);
        this.setUnparsedUserQuery(quotedUnparsedUserQuery);
      }
     },

     tabTransitionUserConstraints: function(fromTab, toTab, fromConstraints, toConstraints) {
        return toConstraints;
     },

     setView: function(name, request, constraint, options) {
       var sourceContextConstraintsModel;
       if (request) {
         if (request.constraint) {
           constraint = request.constraint;
         }
         request = _.clone(request);
         delete request.constraint;

         this.models.search.set(request, { silent: true });
       }

       try {
          this.trigger("changeUserQueryTab", name, constraint);
        } catch (e) {
          if (console && console.warn) console.warn("Failed to trigger changeUserQueryTab", e);
        }

       if (name) {
         var tabToSelect = this.models.tabs.getByName(name);
         var selected = this.models.tabs.getSelectedTab();
         if (tabToSelect) {

           var userConstraints = tabToSelect.get("user_constraints");
          //  var userConstraints = _.extend(
          //                           this.models.search.input.get("user.constraints"),
          //                           tabToSelect.get("user_constraints")
          //                        );

           if (options.tabTransitionUserConstraints
              &&  _.isFunction(options.tabTransitionUserConstraints))
              userConstraints = options.tabTransitionUserConstraints(
                  selected,
                  tabToSelect,
                  this.models.search.get("user.constraints"),
                  userConstraints);

           if (userConstraints) {
             this.models.search.set("user.constraints", clone(userConstraints), {silent: true});
           } else {
             this.models.search.unset("user.constraints", {silent:true});
           }

           var tabUserQuery = clone(tabToSelect.attributes.user_query) || {},
               queryFieldInfo = this.formqueryadapter.queryField() || {path: []};

           var userQueryPath = ["user", "query"].concat(queryFieldInfo.path);
           var userQuery = this.models.search.input.get(userQueryPath);

           if (queryFieldInfo.path.length) {  // we accept other form fields
             if (userQuery)
               JSONPath.set(tabUserQuery, queryFieldInfo.path, userQuery);
           }
           else {
             tabUserQuery = clone(userQuery);
           }

           if (tabUserQuery && !_.isEmpty(tabUserQuery)) {
             this.models.search.set("user.query", tabUserQuery , {silent: true});
           }
           else {
             this.models.search.unset("user.query", null, {silent: true});
           }

           //           var userQueryMap = this.parseQueryExprToLabelMap(this.models.search.get("user.query"));
           //           if (userQueryMap.query) {
           //                  this.models.search.set("user.query", userQueryMap.query, {silent: true});
           //           }
           //           else {
           //             this.models.search.unset("user.query", {silent: true});
           //           }

         }
        }

        if (constraint) {
          // used for selection
          constraint.name = name;

          this.models.search.set("source_context.constraints.view", constraint, options);
        } else if (!this.options.retainViewSourceContextConstraints) {
          sourceContextConstraintsModel = this.models.search.submodel("source_context.constraints");
          sourceContextConstraintsModel.unset("view", options);
          sourceContextConstraintsModel.dispose();
        }
        $(this.rootEls).attr("data-enabled-view", name || "Everything");

        this.models.stack.popToApplication(this);

        try {
          this.trigger("changeviewafter");
        } catch (e) {
          if (console && console.warn) console.warn("Failed to trigger changeviewafter", e);
        }
     },

     showTab: function (options) {
       this.changeView({
         name: options.name
       });
     },

     changeView: function (options) {
        options = options || {};
        options.name = options.name || (options.model && options.model.get("name", { localize: false })) || $(options.eventTarget).text();
        options.model = options.model || this.models.tabs.getByName(options.name);

        if (options.model) {
          var constraint = options["constraints.view"] || options.model.get("constraint");
          var request = clone(options.model.get("request"));
        }

        options.tabTransitionUserConstraints = this.tabTransitionUserConstraints;

        this.setView(options.name, request, constraint, options);
      },

      displayWarning: function (message) {
        window.alert(message);
      },

      openHref: function (options) {
        this.closeMenus();

        var target = options.eventTarget,
            href = options.href,
            disabledSelector = target.getAttribute("data-disabled-selector");

        if (disabledSelector && $(disabledSelector).is(":visible")) {
          return true;
        }

        if (this.handleHrefWithDefaultBrowserAction(href) || target.getAttribute("target")) {
          options["event"].enforceDefault = true;
          return true;
        } else {
          var windowFeatures = '';
          // if href contains text fragment, add noopener property
          if (href.includes("#:~:text=")) {
            windowFeatures = 'noopener';
          }

          window.open(href, this.options.linkOpenTarget || "_blank", windowFeatures);
          return false;
        }
      },

      handleHrefWithDefaultBrowserAction: function (href) {
        return href &&
               /^([a-zA-Z][a-zA-Z0-9$-_@.&]+):.+|#/i.test(href) &&
               !/^(.+[/#?]+.):.+/i.test(href) &&
               !/^(http(s?)|\/):\/\//i.test(href);
      },


      // implement pushStack via launchApplication
      
      pushStack: function(options, traceContext) {
        var launchHandler = this.extensionManager.getApplicationLaunchHandler();
        if (launchHandler) {
          launchHandler.launchApplication(this, _.extend({}, options, {traceContext: traceContext, viewportElement : this.rootEls}));
        }
        else {
          // this.launchApplication(options, traceContext);
          this._pushStack(options, traceContext);
        }
      },
    
      _pushStack: function (options, traceContext) {
        traceContext = traceContext && traceContext.willLeave();
        if (options.useCloneElement) {
          var innerHTML = this.rootElsClone.innerHTML;
        } else if (options.useRootElement) {
          var innerHTML = this.models.stack.get("application").rootElsClone.innerHTML;
        } else {
          var innerHTML = document.getElementById(options["template-ref"]) && document.getElementById(options["template-ref"]).innerHTML
        }
        var title = !_.isUndefined(options.title) ? options.title : $(options.eventTarget).text();
        var stackModel = new Stack.Model({
              title: '<h2>' + title + '</h2>',
              content: options.content
                    || (options["template-ref"]  && innerHTML)
                    || "",
              actionOptions: options,
              previousFocus: options.focused,
              applicationOptions: _.extend({
                  queryURLParameter: "unused"
                },
                options.applicationOptions || {}, {
                  enableAccessibilityHandlers: false,
                  parentApplication: this,
                  callback: function (application) {
                    if (application.options.feedbackHTML5ScreenshotDisabled) {
                      application.feedbackHTML5ScreenshotWasEnabled = Trace.feedbackHTML5ScreenshotEnabled();
                      Trace.enableHTML5Screenshot(false);
                    }
                    try {
                      if (options.action) {
                        application[options.action](_.extend(
                            {},
                            options,
                            {
                              // TODO: coupling alarm
                              titleModel: stackModel,
                              target: $(application.templateTree.rootEls[0]).find("> .mb-stack-content").get(0)
                          }),
                          traceContext
                        );
                      }
                    } finally {
                      traceContext && traceContext.leave();
                    }
                  }
              })
          });

          this.models.stack.push(stackModel);
      },

      preview: function (options, traceContext,e) {
        //@todo here we can access the templateTree.getTemplateById('mb_preview')
        // then use tempate.instances.instances[0].view.render(options, tracecontext)
        // we can therefore delete lots of code from application.js regarding preview rendering
        var actionName = "innerPreview";
        if (options && options.content_location) {
          actionName = "innerContentPreview";
        }
        this.pushStack(_.extend({}, options, {
            action: actionName,
            title: "",
            applicationOptions: _.extend({ feedbackHTML5ScreenshotDisabled: true, queryURLParameter: "unused", startSearch: false }, options.applicationOptions)
        }), traceContext);
      },

      removeCopyPathModal: function() {
        CopyPath.removeModal();
      },

      copyPath: function (options, traceContext,e) {
        CopyPath.actionHandler(options);
      },

      getPropertyHTMLByValue: function (value, properties) {
        try {
          return properties[value].data[0].html;
        } catch (e) {
          console.error("Can not read property " + value + ". The PDF preview will not work correctly. Please make sure that this property is requested as format html.")
          return value;
        }
      },

      setPreviewMarkedEntities: function (inputOptions) {
        if (this.options.entity) {
          this.setPreviewMarkedEntityOptions(inputOptions);

        } else {
          // legacy entity options
          this.setPreviewMarkedEntity('sampleTextMarkEntityTypes', inputOptions);
          this.setPreviewMarkedEntity('sampleTextMarkAllEntityTypes', inputOptions);
        }
      },

      setPreviewMarkedEntityOptions: function (options) {
        if (!_.isUndefined(this.options.entity)) {
          var markAllEntityTypes = this.options.entity.markAllEntityTypes;
          var markEntityTypes = this.options.entity.markEntityTypes;
          var isDisabled = this.entitiesAreDisabledForFeature('preview');

          if (isDisabled === true) {
            // When disabled, always set mark_all_entities to false
            options[StringUtils.camelCaseToSnakeCase("sampleTextMarkAllEntityTypes")] = false;
            return;
          }

          // priorize all entities before explicit entities from the options
          if (!_.isUndefined(markAllEntityTypes)) {
            if (_.isUndefined(markEntityTypes)) {
              // Wenn mark_all_entities is set without the rest, we want to set mark_all_entities
              options[StringUtils.camelCaseToSnakeCase("sampleTextMarkAllEntityTypes")] = markAllEntityTypes;

            } else {
              // When mark_all_entities is set and mark_entities is set, we want to set both as given
              options[StringUtils.camelCaseToSnakeCase("sampleTextMarkAllEntityTypes")] = markAllEntityTypes;
              options[StringUtils.camelCaseToSnakeCase("sampleTextMarkEntityTypes")] = markEntityTypes;

            }
          } else if (!_.isUndefined(markEntityTypes)) {
            // When mark_entities is iset instead we want to set all_entities to false in addition
            options[StringUtils.camelCaseToSnakeCase("sampleTextMarkAllEntityTypes")] = false;
            options[StringUtils.camelCaseToSnakeCase("sampleTextMarkEntityTypes")] = markEntityTypes;

          }

        }
      },

      setPreviewMarkedEntity: function (key, options) {
        var entityOptions = this.options.preview && this.options.preview[key];
        if (!_.isUndefined(entityOptions)) {
          var data = this.getEntityValue(entityOptions, key);
          options[StringUtils.camelCaseToSnakeCase(key)] = data;
        }
      },

      innerPreview: function (options, traceContext) {
        traceContext = traceContext && traceContext.willLeave();
        var that = this;

        this.getPreviewView(_.bind(function (previewView) {
          var defaultChannel = that.models.channels.at(0);
          var model = options.model,
              channel = model && model.channel || defaultChannel,
              location = model.get("location"),
              search = (this.parentApplication || this).models.search.input,
              query = search.get("user.query") || search.get("query");

          if (options.location_path) {
            var properties = JSONPath.get(model.output, options.location_path.split(","));
            if (!_.isEmpty(properties)) {
              location = that.getPropertyHTMLByValue("mes:location", properties);
            }
          }
          if (_.isBoolean(model.output.get("enable_char_ngrams")) && !_.isUndefined(query)) {
            query.enable_char_ngrams = model.output.get("enable_char_ngrams");
          }

          var propertyDefinitions = Common.mergePropertyDefinitions({
            title: {format: "HTML"},
            "mes:summary": {format: "PROPERTY"},
            content: {format: "HTML"},
            extension: {format: "HTML"},
            "html/head": {format: "HTML"},
            "categoryclass": {format: "HTML"},
            "@content": {format: "HTML"}
          }, previewView.getDisplayedProperties());

          var inputOptions = {
            "location": location,
            category: options.category || options.model.get("category", {"format": "VALUE"}),
            categoryinstance: options.categoryinstance || options.model.get("categoryinstance", {"format": "VALUE"}),
            key: options.key,
            query_expr: query,
            full_html: true,                     /* capability for understanding full html */
            "properties": _.reduce(propertyDefinitions, function (defs, value, key) { defs[key] = { formats: [value.format] }; return defs; }, {})
          };

          this.setPreviewMarkedEntities(inputOptions);

          var application =  (that.parentApplication || that);
          if (application.options.disableExternalContextualization) {
            inputOptions.disable_external_contextualization = true;
          }

          var previewInput = this.api.preview.createInput(inputOptions);

          this.api.preview.call(channel,
            previewInput,
            function (response, error) {

              if (response &&
                  response.attributes &&
                  response.attributes["mindbreeze.internal.databytes.content_type"] &&
                  response.attributes["mindbreeze.internal.databytes.content_type"] == "text/html" &&
                  response.attributes.data) {
                previewView.setHtmlPreview(that, response.attributes.data, {traceContext: traceContext, model: options.model});

              }
              else {

                var model, title, result;

                if (response.get("result")) {
                  result = response.submodel("result");
                  model = new PropertiesModel(result.get("properties"), { propertyDefinitions: propertyDefinitions });
                  title = that.getPreviewTitle(model),
                  result.dispose();
                }

                previewView.setPreview(that, model, { traceContext: traceContext })
              }

              if (options.target) {
                options.target.appendChild(previewView.el);
              }
              if (title) {
                options.titleModel && options.titleModel.set("title", "<h2><small class='preview-small-title'>" + i18n("preview") + "</small> " + title + "</h2>");
              }

              traceContext && traceContext.leave();
            },

            {
              traceContext: traceContext,
              clientExtensions: this.getClientExtensions(),
            }
          );
        }, this));
      },

      getPreviewTitle: function (model) {
        //TODO result.ts in standalone chat mode does not pass model to "handleAction"
        return model && model.get("title", { format: "HTML" });
      },

      innerContentPreview: function(options, traceContext) {
        !options.model && console.warn && console.warn("Preview: `model` not provided to action!");

        traceContext = traceContext && traceContext.willLeave();
        var that = this;

        this.getPreviewView(_.bind(function (previewView) {
          var defaultChannel = that.models.channels.at(0);

          var model = options.model,
              channel = model && model.channel || defaultChannel,
              title = this.getPreviewTitle(model),
              search = (this.parentApplication || this).models.search,
              contentPositionPage = model && model.get("mes:contentpositionpage"),
              highlightAnswerText = '';
          var query = search.get("user.query") || search.get("query");
          if (!query || _.isEmpty(query)) {
            query = options.model && (options.model.input.get("user.query")|| options.model.input.get("query"));
          }
          //TODO result.ts in standalone chat mode does not pass model to "handleAction"
          if (model && model.output.get("text") && model.output.get("text").text_start_page) {
            contentPositionPage = model.output.get("text").text_start_page;
            highlightAnswerText = model.output.get("text").text;
          }

          if (options.location_path) {
            var properties = model && JSONPath.get(model.output, options.location_path.split(","));
            if (!_.isEmpty(properties)) {
              title = that.getPropertyHTMLByValue("title", properties);
            }
          }

          var aclConstraint = this.getACLConstraint();
          if (aclConstraint) {
            if (!query || !query.and) {
              query = { and: { query: aclConstraint } }
            } else {
              query.and.aclConstraint = aclConstraint;
            }
          }

          if (model && _.isBoolean(model.output.get("enable_char_ngrams")) && !_.isUndefined(query)) {
            query.enable_char_ngrams = model.output.get("enable_char_ngrams");
          }

          var markedEntities = null;
          if (!_.isUndefined(this.options.entity)) {
            var markAllEntityTypes = this.options.entity.markAllEntityTypes;
            var markEntityTypes = this.options.entity.markEntityTypes;
            var isDisabled = this.entitiesAreDisabledForFeature('pdfPreview');

            try {
              if (isDisabled) {
                markedEntities = 'mark_all_entity_types=false';
              } else {
                // priorize all entities before explicit entities from the options
                if (!_.isUndefined(markAllEntityTypes)) {
                  if (_.isUndefined(markEntityTypes)) {
                    // Wenn mark_all_entities is set without the rest, we want to set mark_all_entities
                    markedEntities = 'mark_all_entity_types=' + markAllEntityTypes;
                  } else {
                    // When mark_all_entities is set and mark_entities is set, we want to set both as given
                    markedEntities = 'mark_all_entity_types=' + markAllEntityTypes + '&mark_entity_types=' + markEntityTypes.join(';');
                  }
                } else if (!_.isUndefined(markEntityTypes)) {
                  // When mark_entities is iset instead we want to set all_entities to false in addition
                  markedEntities = 'mark_all_entity_types=false&mark_entity_types=' + markEntityTypes.join(';');
                }
              }
            } catch (e) {
              if (console && console.warn) console.warn("Failed to set marked entities", e);
            }
          }

          previewView.setContentPreview(
            that,
            _.extend({ query_expr: query, contentPositionPage: contentPositionPage, highlightAnswerText: highlightAnswerText, markedEntities: markedEntities }, options),
            {traceContext: traceContext, channel: channel}
          );

          if (options.target) {
            options.target.appendChild(previewView.el);
          }
          previewView.resize();

          if (title) {
            options.titleModel && options.titleModel.set("title", "<h2><small class='preview-small-title'>" + i18n("preview") + "</small> " + title + "</h2>");
          }

          traceContext && traceContext.leave();


        },this));
      },

      showAlertCenter: function (options) {
        var stackModel = options.sender.options.application.models.stack;

        function alertcenterIsOpen () {
          var stackTree = stackModel,
              foundAlertCenterApplication = false;

          function avail (stackTree) {
            var stackTree = stackTree.get("child");
            if (stackTree) {
              if (stackTree.get("application").name === "alertcenter_application" ) {
                foundAlertCenterApplication = true;
              } else {
                avail(stackTree);
              }
            }
          }
          avail(stackTree);

          if (foundAlertCenterApplication) return true;
          return false;
        }

        if ( alertcenterIsOpen() ) return;

        this.pushStack(_.extend({}, options, {
          "content": '\
          <div class="notification_container">\
          <div>\
              <div data-template="emailalert" data-allow-edit="true"></div>\
            </div>\
            <div>\
              <div data-template="emailalert_preset"></div>\
            </div>\
          </div>',
          title: i18n("client_notifications"),
          applicationOptions: {
            startSearch: false,
            queryURLParameter: "unused",
            toQueryStringQueryURLParameter: this.options.queryURLParameter,
            initializeModels: function(app) {
              app.name = "alertcenter_application"
            }
          }
        }));
      },

      showAbout: function (action) {
        dom.focus($(action.eventTarget).popover({
          template: '<div class="popover mb-role" role="document"><div class="arrow"></div><div class="popover-inner"><div class="popover-content"></div></div></div>',
          placement: "mb-about-popover bottom mb-inverted",
          html: true,
          trigger: "manual",
          content:
            "<div tabindex=\"0\">" +
            "<div class=\"background-container\">" +
            "<img class=\"background\" src=\"" + ResourceInfo.scriptLocation + "../img/about_bg.png\" lang=\"en\" alt=\"Mindbreeze InSpire\">" +
            "</div>" +
            "<h2>" + i18n("Version") + "</h2><p>@@mes.product.version@@</p>" +
            "<h2>" + i18n("vendor") + "</h2><p>" + i18n("vendor_name") + "</p>" +
            "</div>" +
            "<button tabindex=\"-1\" class=\"close btn-link mb-top-right pull-right mb-clickable\">&times;<span class=\"mb-acc\">" + i18n("Close") + "</span></button>"
        }).popover("toggle").data("popover").$tip.on("click", ".close", function () {
          $(".mb-popover-trigger").popover("destroy");
        }));
      },

      triggerAjaxError: function () {
        this.trigger.apply(this, ["ajaxError"].concat(_.toArray(arguments)));
      },

      listenToChannelChanges: function (model) {
        model.get("channels").on("change:enabled", this.onChannelChanged, this);
        model.get("channels").on("add", this.onChannelChanged, this);
      },

      onChannelChanged: function (channel) {
        channel = channel.clone();

        if (channel.get("enabled") === true) {
          var channelAttributes = _.extend({}, channel.attributes);
          this.models.channels.remove(channel);
          this.models.channels.add(channelAttributes, this.channelOptions);
        } else {
          this.models.channels.remove(channel);
        }
      },

      destroy: function (callback) {
        if (this.destroying) return;
        this.destroying = true;
        this.extensionManager.dispose();
        
        $("body").off(".mb-application");

        if (this.options.feedbackHTML5ScreenshotDisabled && this.feedbackHTML5ScreenshotWasEnabled) {
          Trace.enableHTML5Screenshot(true);
        }

        var that = this;
        this.models.search.deactivate();
        if (this.models.tabs) {
          this.models.tabs.dispose();
        }
        this.templateTree.destroy(function() {
          that.destroying = false;
          that.destroyed = true;
          if (callback) callback();
        });

        _.each(this._importedStyleNodes || [], function(node) {
          try {
            node.parentNode.removeChild(node);
          } catch (e) {}
        });
        
        if (this.accessibilityContainer) {
          this.accessibilityContainer.destroy();
        }

        this.trigger("destroy");
        this.stopListening();
      },

      sanitizePath: function (id) {
        if (!id) return;
        return id.replace(/\.|\[|\]|\"|\'/g, "_");
      },

		  handleAction: function (args, actionName, target, model, sender, focused, traceContext, e) {

        var action = this[actionName],
            returnValue;

        var handlerExists = action != null;
        var successful = false;
        var error = null;

        try {
          this.trigger("beforeactionperformed", actionName, {"application": this,
                                                      "model": model,
                                                      "target": target,
                                                      "sender": sender,
                                                      "args": args,
                                                      "traceContext": traceContext,
                                                      "e": e,
                                                      "actionargs":  arguments,
                                                      "handlerExists": handlerExists
                                                     });
        } catch (e) {
          console && console.warn && console.warn("Failed to trigger beforeactionperformed", e);
        }

        var ignoreActionExecution = e && e.ignoreActionExecution;
        if (action && !ignoreActionExecution) {
          try {
            returnValue = action.apply(
              this,
              [
                _.extend({
                    "event": e,
                    eventTarget: target,
                    sender: sender,
                    model: model,
                    focused: focused,
                    // TODO: get("id")?,
                    id: model && model.output && model.output.id
                }, args),
                traceContext
              ]
            );
            successful = true;
          } catch (e) {
            if (console && console.error) console.error("Failed to execute action", action, e.stack, e);
            error = e;
          }

          this.trigger("actionHandled");

          if (typeof returnValue === "undefined") {
            returnValue = false;
          }
          // return returnValue;
        }

        try {
          // var eventArgs = ["handeledaction"].concat(arguments);
          // this.trigger.apply(this, eventArgs);
          this.trigger("actionperformed", actionName, {"application": this,
                                                      "model": model,
                                                      "target": target,
                                                      "sender": sender,
                                                      "args": args,
                                                      "traceContext": traceContext,
                                                      "e": e,
                                                      "actionargs":  arguments,
                                                      "handlerExists": handlerExists,
                                                      "returnValue": returnValue,
                                                      "error": error });
        } catch (e) {
          if (console && console.warn) console.warn("Failed to trigger actionperformed", e);
        }


        return returnValue;
      },

      resetUser: function(options) {
        this.models.search.input.unset("user", { traceContext: options && options.traceContext, silent: options && options.silent });
      },

      resetFilters: function(options) {
        var userQueryPath = this.getUnparsedUserQueryPath(),
            model = options.model || this.models.search,
            query = model.get(userQueryPath);

        if (query) {
          model.deactivate();
          model.input.unset("user", options);
          model.input.set(userQueryPath, query, options);
          model.activate();
        }
      },

      resetQuery: function(options) {
        if($('#query').length) {
          $("#query").val("").focus();
          this.trigger("resetQuery");
          if (options && options.startNewSearch === "true") {
            this.models.search.set(this.getUnparsedUserQueryPath().join('.').split('.query.unparsed')[0], { query: "" });
          }
        }
      },

      resetSearch: function(options) {
        this.trigger("resetSearch");
        options = { traceContext: options && options.traceContext, silent: options && options.silent }
        this.resetUser(options);
        this.models.search.output.reset(null, options);
        var activeTabName = this.models.tabs.getSelectedTabName();
        if (activeTabName) {
          this.changeView({ name: activeTabName})
        }
        $("[autofocus]").focus();
      },

      setValue: function (options, traceContext) {
        var input = options.model.input || options.model;
        input.set(options.key, options.value, { traceContext: traceContext });
      },

      unsetValue: function (options, traceContext) {
        var input = options.model.input || options.model;
        input.unset(options.key, { traceContext: traceContext });
      },

      addValue: function (options, traceContext) {
        var input = options.model.input || options.model;
        input.add(options.key, options.value, { traceContext: traceContext });
      },


      _recomputePersonalizationProfile: function(collected) {
        var keys = [];
        collected.each(function (collectResult) {
          keys.push(collectResult.get("key"));
        });

        var patterns = _.map(keys, function(key) { return {label: "mes:key", regex: "\\Q" + key + "\\E" } });
        var profile = patterns.length > 0 ?   { factor: this._personalizeSearchBoost, query_expr: { or: patterns }} : null;
        return profile;
      },

      _onModelecomputeProfile: function(model, collected) {
          var that = this;
          this.models.search.input.set("boostings.userprofile",
                                       this._recomputePersonalizationProfile(collected),
                                       {silent:true});
      },

      personalizeSearch: function(boost, options) {
        var options = options || {},
            boostingsModel;

        if (this._personalizeSearchBoost == boost) {
          return ;
        }

        this._personalizeSearchBoost = boost;

        // 2 cases
        if (boost > 0) {
          if (!this.models.collected) return;

          // introduce the
          this.models.search.input.set("boostings.userprofile",
                                       this._recomputePersonalizationProfile(this.models.collected),
                                       options);
          this.models.collected.on("add remove", this._onModelecomputeProfile, this);
        }
        else {
          this.models.collected.off("add remove", this._onModelecomputeProfile, this);
          boostingsModel = this.models.search.input.submodel("boostings");
          boostingsModel.unset("userprofile", { silent: true });
          boostingsModel.dispose();
          this.models.search.input.set("boostings.profiledboost", options);
        }
      },

      changeOrderBy: function (options) {
        this.models.search.set("orderby", options.eventTarget.value);
      },

      changeSummarizeBy: function (options) {
        var value = options.value || options.eventTarget.value;
        if (value) {
          var summarize_by_search = this.models.search.get("summarize_by") || {};
          summarize_by_search[options.key] = value;
          this.models.search.set("summarize_by", summarize_by_search);
        } else {
          this.models.search.unset("summarize_by");
        }
        options.event.stopPropagation();
      },

      changeGroupBy: function (options) {
        var value = options.eventTarget.value;
        if (value) {
          this.models.search.set("groupby.property", value);
        } else {
          this.models.search.unset("groupby");
        }
      },

      getUserConstraints: function () {
        return this.models.search.input.get("user.constraints");
      },

      setUserConstraints: function (userConstraints) {
        if (userConstraints) {
          this.models.search.set("user.constraints", userConstraints);
        } else {
          this.models.search.unset("user.constraints");
        }
      },

      getUnparsedUserQueryPath: function () {
        var queryFieldInfo = this.formqueryadapter.queryField(),
            userQueryPath = ["user", "query"].concat(queryFieldInfo.path).concat("unparsed");

        return userQueryPath;
      },

      getUnparsedUserQuery: function () {
        return this.models.search.input.get(this.getUnparsedUserQueryPath());
      },

      setUnparsedUserQuery: function (unparsedUserQuery, options) {
        var userQueryPath = this.getUnparsedUserQueryPath()

        if (unparsedUserQuery) {
          options = _.extend({}, options, {path: userQueryPath});
          this.models.search.set(null, unparsedUserQuery, options);
        } else {
          this.models.search.unset(userQueryPath, options);
        }
      },

      getUserContext: function () {
        var user_context = {};
        user_context.locale = i18n.locale;
        return user_context;
      },

      // openSearch
      // ----------
      //
      // API: Public Action
      //
      // ### Paramters
      //
      // * **href** the OpenSearch-URL, can also be specfified with the attribute data-href instead
      // * **[searchTerms]** a pre-replacement of searchTerms, e.g. "{searchTerms} product" will yield a search for the user query and product
      openSearch: function (options) {
        var searchTerms = options.searchTerms || "{searchTerms}",
            href = options.href || options.eventTarget.getAttribute("data-href"),
            unparsedUserQuery = this.getUnparsedUserQuery(),
            query, url;

        if (!href) return;

        if (unparsedUserQuery) {
          query = searchTerms.replace(/\{searchTerms\}/g, unparsedUserQuery);
          url = href.replace(/\{searchTerms\}/g, encodeURIComponent(query));
          url = url.replace(/\{language\}/g, i18n.locale);
          window.open(url);
        } else {
          this.displayWarning(i18n("missing_query"));
        }
      },

      openExpandable: function (options) {
        var that = this,
            eventId = _.uniqueId("event"),
            enabledSelector = options.eventTarget.getAttribute("data-enabled-selector"),
            controlledId = options.id || options.eventTarget.getAttribute("aria-controls"),
            controlledEl = document.getElementById(controlledId);

        if (enabledSelector && !$(enabledSelector).is(":visible")) {
          return true;
        }

        if (options.eventTarget.hasAttribute("aria-expanded")) {
          options.eventTarget.setAttribute("aria-expanded", "true");
        }
        controlledEl.setAttribute("aria-expanded", "true");
        $("body").addClass(controlledId + "-visible");
          dom.focus(controlledEl);

        if (options.closeOnFocusout) {
          $(controlledEl).on("focusout." + eventId, function () {
              window.setTimeout(function () {
                  var focusInControlledEl = dom.isChild(document.activeElement, controlledEl);
                  if (!focusInControlledEl) {
                    $(controlledEl).off("focusout." + eventId);
                    that.closeExpandable(options);
                  }
                }, 10);
          });
        }
      },

      closeExpandable: function (options) {
        var controlledId = options.id || options.eventTarget.getAttribute("aria-controls"),
            controlledEl = document.getElementById(controlledId);

        if (options.eventTarget && options.eventTarget.hasAttribute("aria-expanded")) {
          options.eventTarget.setAttribute("aria-expanded", "false");
        }
        controlledEl.setAttribute("aria-expanded", "false");
        $("body").removeClass(controlledId + "-visible");
      },

      toggleExpandable: function (options) {
        var controlledId = options.id || options.eventTarget.getAttribute("aria-controls"),
            controlledEl = document.getElementById(controlledId),
            expandedAttrEl = options.eventTarget.hasAttribute("aria-expanded") ? options.eventTarget : controlledEl,
            expanded = expandedAttrEl.hasAttribute("aria-expanded") ? !(expandedAttrEl.getAttribute("aria-expanded") === "false") : $(expandedAttrEl).is(":visible");

        if (expanded) {
          this.closeExpandable(options);
        } else {
          this.openExpandable(options);
        }
      },

      changeLocale: function (options) {
        this.setLocale(options.lang);
      },

      setPage: function (options) {
        var page = options.page;
        if (page < 0) return;

        if (options.model.loadPage) {
          this.options.active_page = parseInt(options.page);
          options.model.loadPage(options);
        }
      },

      previousPage: function (options) {
        if (options && options.model && options.model.previousPage) {
          options.model.previousPage(options);
        } else {
          var pages = options.model.get("pages");
          var currentPage = _.find(pages, function (page) { return page.current_page; });
          if (currentPage) {
            this.setPage(_.extend({}, options, { page: currentPage.page_number - 1 }));
          }
        }
      },

      nextPage: function (options) {
        if (options && options.model && options.model.nextPage) {
          options.model.nextPage(options);
        } else {
          var pages = options.model.get("pages");
          var currentPage = _.find(pages, function (page) { return page.current_page; });
          if (currentPage) {
            this.setPage(_.extend({}, options, { page: currentPage.page_number + 1 }));
          }
        }
      },

      //360 view -- start --
      showPreview: function (options, traceContext) {
        this.getExtensionManager().get360Module().showPreview(options, traceContext);
      },
  
      show360: function (options) {
        this.getExtensionManager().get360Module().show360(options);
      },
  
      '360view': function (options) {
        this.getExtensionManager().get360Module().view360(options);
      },
  
      transform360Input: function (destItemClassName, segmentInput) {
        try {
          return this.getExtensionManager().get360Module().transform360InputForResult(destItemClassName, segmentInput);
        } catch (error) {
          console.warn("Failed to transform 360 input for result, skipped.", error.message)
        }
      },

      showAllResults: function(options){
        this.getExtensionManager().get360Module().showAllResults(options);
      },

      setOnSearchModel: function (options) {
        this.getExtensionManager().get360Module().setOnSearchModel(options);
      },

      getAppFragmentStore: function() {
        var appFragmentStoreV1 = this.clientExtensions.getPersistedAppFragmentStoreV1 && this.clientExtensions.getPersistedAppFragmentStoreV1();
        if (!appFragmentStoreV1) {
          appFragmentStoreV1 = this.clientExtensions.getReadonlyAppFragmentStoreV1();
        }

        return appFragmentStoreV1;
      },

      serializeSearchModelToURLParamsString: function (searchModel) {
        var model = searchModel || this.models.search;
        var querySearchParamName = this.options.queryURLParameter;
        return NavigationQueryParams.toQueryString(model, querySearchParamName);
      },


      activateSearchAndOptionalTiggerQuery: function(startSearch, searchOnUserQuery) {
        var userQuery = this.getUnparsedUserQuery();
        startSearch = ((userQuery != null && userQuery) && searchOnUserQuery) || startSearch;

        if (userQuery) {
          this.setUnparsedUserQuery(userQuery, { forceUIUpdate: true, triggerActionName: "initialUserQuery" });
        }
        this.models.search.activate(startSearch ? {} : {silent: true});
      },

      searchModelToURLParamsObject: function (searchModel) {
        var model = searchModel || this.models.search;
        var querySearchParamName = this.options.toQueryStringQueryURLParameter;
        const serializedQueryFromSearchmodel = NavigationQueryParams.toQueryString(model, querySearchParamName);
        return NavigationQueryParams.queryStringToObject(serializedQueryFromSearchmodel) 
      },
      
      
  });

  Application.VERSION = "@@mes.product.version@@";


  return Application;
 });
